/* eslint-disable react-hooks/exhaustive-deps*/
import { React, useEffect, useRef, useState } from "react";
import { newSessionUID, APPFACTOR, uuidv4, capitalize, decamelize, appFactorColors, getApiUrl } from "./commons";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from '@mui/material/TextField';
import FormControl from "@mui/material/FormControl";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Autocomplete from '@mui/material/Autocomplete';
import { poolData } from "../UserPool";
import CloudUploadIcon from '../asset/scan/CloudUploadIcon';
import { styled } from '@mui/material/styles';
import { DialogLogo } from "./APPF_ICONS";
import { AWS_REGIONS } from "../constant";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { JsonViewer } from '@textea/json-viewer';
import { isValidUrl } from "./newAppComponent";
import { setTheConfig } from "./EnterSecretPassword";
import { LabelShapeSVG } from "../../3d/src/App";
import HorizontalMenu from "./HorizontalMenu";

const clearList = ["scan_secretName", "scan_username", "scan_password", "key_data", "scan_access_key", "scan_access_secret"];
const labelColor = "var(--text-color-add-form)";

const sLevel1 = {
    justifyContent: "flex-start",
    margin: 0,
    marginTop: 30,
    flex: 1,
    minWidth: 300,
    maxWidth: 100,
    with: 300,
    float: "left"
};

const sLevel2 = {
    flex: 0.2,
    marginLeft: 10,
    minWidth: 130,
    maxWidth: 150
};
const mll = 32;

const tfield = {
    style: sLevel2,
    type: "text",
    // variant: "outlined",
    autoComplete: "one-time-code"
};


const HImput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1
});

function IFileUpload(props) {
    return (
        <Button
            className="add-credential-file-upload"
            style={{
                backgroundColor: "transparent",
                border: "none",
                color: "var(--text-color-add-form)",
                boxShadow: "none",
                maxWidth: 130,
                minWidth: 139,
                paddingLeft: 0,
                paddingRight: 6,
                fontSize: 16
            }}
            component="label"
            role={undefined}
            variant="contained"
            endIcon={<CloudUploadIcon style={{ width: 28, height: 28 }} />}
        >
            {props.name ? props.name : ""}
            <div
                style={{
                    maxWidth: 1,
                    minWidth: 1
                }}
            >
                <HImput
                    type="file"
                    onChange={async (e) => {
                        try {
                            const file = e.target.files.item(0);
                            const data = await file.text();

                            try {
                                if (data != "") {
                                    document.querySelector("#key_data").value = data;
                                    e.target.value = "";
                                }
                            } catch (e) { /* */ }
                        } catch (e) { /* */ }
                    }}
                />
            </div>
        </Button>
    );
}
const colorHashiCorpVault = "#FFCF25";
const ICON_HASHICORP_VAULT = <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"

    style={{ marginTop: 4, marginRight: 8, position: "absolute", marginLeft: -4 }}
>
    <g clipPath="url(#clip0_6570_6855)">
        <path
            d="M0 0L7.971 15.516L16 0H0ZM6.732 6.16H5.462V4.89H6.732V6.16ZM6.732 4.254H5.462V2.985H6.732V4.254ZM8.636 8.064H7.366V6.794H8.636V8.064ZM8.636 6.159H7.366V4.89H8.636V6.159ZM8.636 4.254H7.366V2.985H8.636V4.254ZM10.53 6.159H9.26V4.89H10.53V6.159ZM9.26 4.254V2.985H10.53V4.254H9.26Z"
            fill={colorHashiCorpVault}
        />
    </g>
    <defs>
        <clipPath id="clip0_6570_6855">
            <rect width={16} height={16} fill="white" />
        </clipPath>
    </defs>
</svg>


const hashiFields = ["url", "namespace", "role_id", "secret_id", "approle"]

function HashSettings(props) {
    const indexOffset = 20;
    const sstyle = {
        flex: 1,
        // width: "calc(66% - 42px)",
        width:"calc(100% - 100px)",
        // minWidth:"calc(100% - 90px)",
        // maxWidth:"calc(100% - 90px)",
        marginLeft: 10,
        marginTop: 4,
    }

    const [errorText, setErrorText] = useState("");
    const fields = [
        { id: hashiFields[0] },
        { id: hashiFields[1], label: hashiFields[1].split("_").join(" ") },
        { id: hashiFields[2], label: hashiFields[2].split("_").join(" ") },
        { id: hashiFields[3]},
        { id: hashiFields[4]}
    ]

    const [enableDetails, setEnableDetails] = useState(false);
    const [hashiAuthType, setHashiAuthType] = useState(props?.hashicorpVaultSettings?.type || "approle");

    try {
        console.log(props.response.errors[0])
    } catch (e) {
        /* */
    }
    return (
        <Dialog open={props.open} onClose={props.onClose}
            slotProps={{
                paper: {
                    tabIndex: -1,
                    className: "niceBorder animateBorder",
                    sx: {
                        width: "640px",
                        maxWidth: "640px",
                        minWidth: "640px",
                        opacity: 1,
                        fontSize: "14px",
                        paddingBottom: "20px",
                        backgroundColor: "black",
                        background: "linear-gradient(174.69deg, #202020 2.73%, #321B17 94.22%)",//"rgba(32,32,32,1)
                        // height: "100%",
                        minHeight: "210px ",
                        paddingTop: "0px",
                        overflow: "visible",
                    },
                },

            }}
        >
            <DialogTitle style={{ fontSize: "16px", paddingLeft: "30px" }}>
                <div style={{ display: "inline-block", transform: "scale(1.5) translateY(-12px)", transformOrigin: "0% 0%" }}>{ICON_HASHICORP_VAULT}</div>
                <div style={{ display: "inline-block", paddingLeft: 30, marginTop: 6, position: "absolute", marginLeft: 6 }}>HashiCorp Vault - Settings</div></DialogTitle>
            <DialogContent>
                <div
                    className="hashicorpSettings"
                    style={{
                        height: "460px",
                        display: "flex",
                        flexDirection: "column",
                        gap: 10,
                        marginTop: "-24px",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: 20,
                        marginLeft: -15,
                        position: "relative",
                        overflow: "visible",
                    }}>
                    <div style={{
                        position: "absolute",
                        marginTop: 100,
                        marginLeft: 13,
                        transform: "scale(2.4)"
                    }}>

                        <LabelShapeSVG  width={230} height={180} searchLogo={false} />
                    </div>

                    <div style={{
                        position: "absolute",
                    }}>
                        <RadioGroup
                            slotProps={{ htmlInput: { tabIndex: -1 } }}
                            className="add-credential-radio-group noBG"
                            aria-labelledby="runScanUsing"
                            name="hasiAuthType"
                            value={hashiAuthType}
                            onChange={(a, b) => {
                                setHashiAuthType(b);
                                props.setHashiAuthType(b);
                                try {
                                    setTimeout(() => {
                                        document.querySelector(".hf-token input").focus();
                                    }, 100);
                                } catch (e) {
                                    /* */
                                }

                            }}
                            style={{
                                transform: "scale(0.72)",
                                // pointerEvents: disable1 ? "none" : "all",
                                // opacity: disable1 ? 0 : 1,
                                margin: 0,
                                marginTop: -151,
                                marginLeft: -285,
                                zIndex: 100,
                                padding: 0,

                                display: "flex",
                                flexDirection: "row",
                                color: "var(--text-color-add-form)",
                            }}
                        >
                            {["approle", "token"].map((type, index) => (
                                <FormControlLabel
                                    title={`Authenticate to HashiCorp Vault using : ${type}`}
                                    key={index}
                                    value={type}
                                    control={
                                        <Radio tabIndex={-1} className="add-credential__radio-button" />}
                                    label={capitalize(decamelize(type))}
                                    style={{
                                        padding: 0,
                                        marginLeft: 0,
                                        justifyContent: "left",
                                        textDecoration: type == hashiAuthType ? "underline" : "none",
                                        color: type == hashiAuthType ? "var(--text-color-full)" : "var(--text-color-add-form"
                                    }}
                                />
                            ))}



                        </RadioGroup>
                    </div>
                    {(hashiAuthType == "approle" ? fields :
                        [
                            { id: hashiFields[0] },
                            { id: "token1", label: "Token" },
                            { id: "namespace", label: "Namespace" },
                            { id: "token", label: "Token" },
                            { id: "token2", label: "Token" }
                        ]
                    ).map((field, i) => {
                        let defaultValue = ""
                        let namespaceValue = ""
                        if (i == 0) {
                            namespaceValue = props?.hashicorpVaultSettings?.namespace || ""
                        }
                        try {
                            if (field.id == "approle") {
                                if (props?.hashicorpVaultSettings?.[field.id]?.length == 0 || typeof props?.hashicorpVaultSettings?.[field.id] === 'undefined') {
                                    defaultValue = "approle"
                                } else {
                                    defaultValue = props.hashicorpVaultSettings[field.id]
                                }
                            } else {
                                if (props.hashicorpVaultSettings[field.id]?.length == 0 || typeof props.hashicorpVaultSettings[field.id] === 'undefined') {
                                    defaultValue = ""
                                }
                                else {
                                    defaultValue = `${props.hashicorpVaultSettings[field.id]}`
                                }

                            }

                        }
                        catch (e) {
                            /* */
                        }

                        const marginVal = -40;
                        return (<>
                            <div
                                className={`hf-${field.id}`}
                                key={field.id}
                                style={{
                                    pointerEvents: hashiAuthType == "approle" ? "all" : ((field.id == "token" || field.id == "url" || field.id == "namespace") ? "all" : "none"),
                                    opacity: hashiAuthType == "approle" ? 1 : ((field.id == "token" || field.id == "url" || field.id == "namespace") ? 1 : 0),
                                    marginTop: `${i == 0 ? -40 : (i == 1 ? marginVal : 0)}px`,
                                    textTransform: `${i != 0 ? "capitalize" : "uppercase"}`,
                                    minHeight: "56px",
                                    marginLeft: `${i == 0 ? 4 : 30}px`,
                                    width: `calc(100% - ${i == 0 ? 12 : (marginVal + 124)}px)`,
                                    textAlign: "center",
                                    paddingTop: `${(i == 1 ? 70 : 0)}px`,
                                    paddingBottom: `${(i == 0 ? 20 : (i == fields.length - 1) ? marginVal + 20 : 0)}px`
                                }}
                            >
                                <div
                                    style={{
                                        textAlign: "right",
                                        position: "absolute",
                                        fontSize: 12,
                                        marginLeft: -28,
                                        marginTop: 14,
                                        minWidth: 80,
                                        color: "var(--text-color-add-form)",
                                        // border:"1px solid red",
                                        flex: 1,
                                        display: "inline-block",
                                        justifyContent: "flex-start",
                                        flexDirection: "column",
                                    }}>
                                    {i == 0 ? "" : (field?.label || field.id)}</div>
                                <TextField
                                    autoFocus={i == 0}
                                    onKeyUp={(e) => {
                                        if (e.key === 'Enter') {
                                            document.getElementById("checkSettings").click();
                                        }
                                    }}
                                    slotProps={{ htmlInput: { tabIndex: (hashiAuthType == "approle" ? (indexOffset + (i * 2)) : ((field.id == "token" || field.id == "url" || field.id == "namespace") ? 20 + i : -1)) } }}
                                    className="add-credential-input"
                                    autoComplete={'one-time-code'}
                                    id={field.id}
                                    name={field.id}
                                    placeholder={i == 0 ? "Enter HashiCorp Vault url ..." : ""}
                                    defaultValue={defaultValue}
                                    type={(field.id == "secret_id" || field.id == "token") ? "password" : "text"}
                                    style={{
                                        ...sstyle,
                                        textAlign: "center",
                                        // display:"inline-block",
                                    }}
                                    sx={{
                                        "& input": {
                                            marginLeft: i==0?"2px":"52px",
                                            background: i == 0 ? "rgba(0,0,0,0.9) !important" : "rgba(24,24,24,0.42) !important",
                                        }
                                    }}
                                />
                                
                            </div>
                            {i == fields.length - 1 &&
                                <>
                                    <div
                                        style={{
                                            bottom: 42,
                                            position: "absolute",
                                            width: "400px",
                                            marginLeft: -140
                                        }}
                                    >
                                        {errorText && <div style={{
                                            position: "absolute",
                                            borderRadius: 4,
                                            paddingTop: "6px",
                                            paddingBottom: "6px",
                                            paddingLeft: 10,
                                            background: `rgba(226, 6, 6, 0.082)`,
                                            textAlign: "left", color: "#F74237",
                                            fontSize: 12,
                                            marginTop: -34,
                                            marginLeft: 74,
                                            width: "calc(100% - 140px)"
                                        }}>
                                            {errorText}
                                        </div>}
                                        {enableDetails && (props.response) &&

                                            <div style={{ textAlign: "left", color: "red", fontSize: 12, marginTop: 0, padding: 0, borderRadius: 5, width: "calc(100%)" }}>
                                                {errorText}
                                                {props.response.errors ?
                                                    <div style={{
                                                        background: `rgba(226, 6, 6, 0.082)`,
                                                        position: "absolute",
                                                        // textTransform:"capitalize",
                                                        textAlign: "left",
                                                        color: "#F74237",
                                                        minHeight: 32,
                                                        maxHeight: 44,
                                                        fontSize: 12,
                                                        marginTop: -38,
                                                        marginLeft: "54px",
                                                        paddingTop: "4px",
                                                        paddingLeft: 10,
                                                        borderRadius: 8,
                                                        width: "calc(100% - 130px)"
                                                    }}>
                                                        {props.response?.checkURL ?
                                                            <a
                                                                href={props.response.checkURL}
                                                                target="_blank"
                                                                style={{
                                                                    borderRadius: 4,
                                                                    padding: 3,
                                                                    paddingLeft: 10,
                                                                    paddingRight: 10,
                                                                    backgroundColor: "#FFFFFFEA",
                                                                    fontSize: 12,
                                                                    marginBottom: 10, color: "#F74237", position: "absolute", marginTop: -24, marginLeft: "-10px"
                                                                }}>{props.response.checkURL}</a> : ""}

                                                        {props.response.errors.length == 1 ? props.response.errors[0]?.split('\n').
                                                            map((subStr) => {
                                                                return (
                                                                    <>
                                                                        {

                                                                            subStr.split('\t').
                                                                                map((subStr2) => {
                                                                                    return (
                                                                                        <div style={{
                                                                                            display: "inline-block",
                                                                                            marginLeft: 10
                                                                                        }}>
                                                                                            {subStr2}
                                                                                        </div>
                                                                                    )
                                                                                })

                                                                        }
                                                                        <br />
                                                                    </>
                                                                )
                                                            }) : props.response.errors.join(", ")}
                                                    </div>
                                                    :
                                                    <JsonViewer
                                                        defaultInspectDepth={0}
                                                        collapseStringsAfterLength={26}
                                                        tabIndex={-1}
                                                        style={{
                                                            "--Paper-overlay": "rgba(0,0,0,0)",
                                                            maxWidth: "calc(100% - 140px)",
                                                            marginLeft: 54,
                                                            maxHeight: 385,
                                                            padding: 10,
                                                            overflow: "auto",
                                                        }}
                                                        quotesOnKeys={false}
                                                        rootName={false}
                                                        value={props.response.errors ? props.response.errors : props.response}
                                                        theme={{ ...appFactorColors, base00: "#000000" }}
                                                        maxDisplayLength={10}
                                                        displaySize={false}
                                                        enableClipboard={true}
                                                        indentWidth={4}
                                                        displayDataTypes={false}
                                                        iconStyle={"circle"}
                                                    />
                                                }
                                            </div>
                                        }
                                    </div>
                                    <div style={{
                                        position: "absolute",
                                        marginLeft: 20,
                                        zIndex: 1000,
                                        color: "rgba(255,255,255,0.42)",
                                        bottom: 52,
                                    }}>
                                        {!props.loginFinished ? " Connecting ..." : ""}
                                    </div>
                                    <div style={{
                                        position: "absolute",
                                        // marginLeft:200,
                                        right: props.hashicorpVaultToken ? 260 : 140,
                                        zIndex: 1000,
                                        color: enableDetails && props.loginFinished ? props.hashicorpVaultToken ? "#4EAF4E" : "#F74237" : "transparent",
                                        bottom: props.hashicorpVaultToken ? 52 : 22,
                                    }}>{props.hashicorpVaultToken ? "SUCCESS" : "FAIL"}</div>
                                    <Button
                                        tabIndex={indexOffset + fields.length + 2}
                                        id="checkSettings"
                                        className={`scanButton add-credential__save`}
                                        sx={{
                                            border: props.loginFinished ?
                                                (props.hashicorpVaultToken ? "1px solid #4EAF4E !important" : "1px solid rgba(255,44,44,0.8) !important") : "trasnsparent",
                                            //  marginLeft: "14px",
                                            marginTop: "0x",
                                            transform: "scale(0.8)",
                                            backgroundColor: "rgba(222,222,239,0.1) !important",
                                            position: "absolute",
                                            bottom: 42,
                                            right: 58,
                                            maxWidth: "150px",
                                            paddingLeft: "0px !important",
                                            paddingRight: "0px !important",
                                            borderRadius: "4px !important",
                                        }}
                                        onClick={() => {
                                            setEnableDetails(false);
                                            setTimeout(() => {
                                                setEnableDetails(true);
                                            }, 300);
                                            props.setHashicorpVaultToken(null);
                                            props.setResponse("");
                                            setErrorText("");

                                            let newSettings = {}
                                            if (hashiAuthType == "approle") {
                                                newSettings = {
                                                    [`${hashiFields[0]}`]: document.getElementById(hashiFields[0]).value,
                                                    [`${hashiFields[1]}`]: document.getElementById(hashiFields[1]).value,
                                                    [`${hashiFields[2]}`]: document.getElementById(hashiFields[2]).value,
                                                    [`${hashiFields[3]}`]: document.getElementById(hashiFields[3]).value,
                                                    [`${hashiFields[4]}`]: document.getElementById(hashiFields[4]).value,
                                                    type: hashiAuthType,
                                                    check: `${Math.random()}`
                                                }
                                                if (document.getElementById("namespace").value !== "") {
                                                    newSettings["namespace"] = document.getElementById("namespace").value;
                                                }else{
                                                    delete newSettings.namespace;
                                                }
                                            } else {
                                                newSettings = {
                                                    [`${hashiFields[0]}`]: document.getElementById(hashiFields[0]).value,
                                                    token: document.getElementById("token").value,
                                                    type: hashiAuthType,
                                                    check: `${Math.random()}`
                                                }
                                                if (document.getElementById("namespace").value !== "") {
                                                    newSettings["namespace"] = document.getElementById("namespace").value;
                                                }else{
                                                    delete newSettings.namespace;
                                                }

                                            }

                                            const allSettingsHaveValue =
                                                Object.values(newSettings).every(
                                                    v => typeof v === 'string' && v.length > 0
                                                );

                                            if (allSettingsHaveValue) {
                                                props.setSettings(newSettings);
                                            } else {
                                                setErrorText("Please fill all the fields.");
                                            }


                                        }}
                                    > Check settings
                                    </Button>
                                    {props.loginFinished && <>
                                        {props.hashicorpVaultToken ? <>
                                            <svg
                                                width={14}
                                                height={14}
                                                viewBox="0 0 18 18"
                                                fill="none"
                                                style={{ bottom: 68, position: "absolute", marginLeft: 175 }}
                                            >
                                                <g clipPath="url(#clip0_6232_7692)">
                                                    <path
                                                        d="M9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM7.5 12.75L3.75 9L4.8075 7.9425L7.5 10.6275L13.1925 4.935L14.25 6L7.5 12.75Z"
                                                        fill="#4EAF4E"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_6232_7692">
                                                        <rect width={18} height={18} fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </> : <>
                                            <svg
                                                width={14}
                                                height={14}
                                                viewBox="0 0 48 48"
                                                fill="none"
                                                style={{ marginTop: 350, position: "absolute", marginLeft: 173 }}
                                            >
                                                <g clipPath="url(#clip0_6215_6758)">
                                                    <path
                                                        d="M24 4C12.96 4 4 12.96 4 24C4 35.04 12.96 44 24 44C35.04 44 44 35.04 44 24C44 12.96 35.04 4 24 4ZM26 34H22V30H26V34ZM26 26H22V14H26V26Z"
                                                        fill="#F74237"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_6215_6758">
                                                        <rect width={48} height={48} fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>

                                        </>}
                                    </>
                                    }
                                </>}
                        </>)
                    })}
                </div>


            </DialogContent>
            <DialogActions
                style={{
                    display: "flex",
                    flexDirection: "column",
                    marginTop: 0,
                    marginLeft: 0,
                    position: "relative",
                    justifyContent: "left",
                    gap: 0,
                    paddingTop: 0,
                }}
            >
                <div
                    style={{
                        width: "calc( 100% - 120px)",
                        marginTop: 6,
                        marginLeft: "-2px",
                        position: "relative",
                        justifyContent: "left",
                        gap: 0,
                        paddingTop: 0,
                        paddingBottom: 0
                    }}
                >

                    <Button
                        tabIndex={indexOffset + fields.length + 2}
                        id="savecred"
                        className="scanButton add-credential__save"
                        sx={{
                            transformOrigin: "0% 0%",
                            transform: "scale(0.8)",
                            backgroundColor: "rgba(222,222,239,0.1) !important",
                            marginRight: "0px",
                        }}
                        onClick={() => {
                            setErrorText("");

                            let newSettings = {}

                            if (hashiAuthType == "approle") {
                                newSettings = {
                                    [`${hashiFields[0]}`]: document.getElementById(hashiFields[0]).value,
                                    [`${hashiFields[1]}`]: document.getElementById(hashiFields[1]).value,
                                    [`${hashiFields[2]}`]: document.getElementById(hashiFields[2]).value,
                                    [`${hashiFields[3]}`]: document.getElementById(hashiFields[3]).value,
                                    [`${hashiFields[4]}`]: document.getElementById(hashiFields[4]).value,
                                    type: hashiAuthType,
                                }

                                if (document.getElementById("namespace").value !== "") {
                                    newSettings["namespace"] = document.getElementById("namespace").value;
                                }else{
                                    delete newSettings.namespace;
                                }

                            } else {
                                newSettings = {
                                    [`${hashiFields[0]}`]: document.getElementById(hashiFields[0]).value,
                                    token: document.getElementById("token").value,
                                    type: hashiAuthType,
                                }

                                if (document.getElementById("namespace").value !== "") {
                                    newSettings["namespace"] = document.getElementById("namespace").value;
                                }else{
                                    delete newSettings.namespace;
                                }
                            }

                            const allSettingsHaveValue =
                                Object.values(newSettings).every(
                                    v => typeof v === 'string' && v.length > 0
                                );

                            if (allSettingsHaveValue) {
                                localStorage.setItem("hashicorpVaultSettings", JSON.stringify(newSettings));

                                setTheConfig(getApiUrl(poolData.envURL), poolData, newSettings[hashiFields[0]], newSettings["namespace"]);

                                props.onClose();
                            } else {
                                setErrorText("Please fill all the fields");
                            }
                        }}
                    > Save settings
                    </Button>

                    <Button
                        tabIndex={-1}
                        className="add-credential__cancel"
                        sx={{
                            transformOrigin: "0% 0%",
                            transform: "scale(0.8)",
                        }}
                        style={{
                            marginLeft: "0px",
                            paddingLeft: "0px",
                        }}
                        onClick={() => {
                            props.onClose();
                        }}
                    >
                        Cancel
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    )
}


// The ids of the secret/protocol requests this screen is waiting on.
//
// The reply handler used to match `id.startsWith("42000")`, which is a prefix
// short enough to be case-safe - the orchestrator parses the id as a UUID and
// echoes it lower-cased, so the upper-case tails generated below never come back
// as they were sent. secretCreated() works around the same thing with an
// explicit .toLowerCase() just here.
//
// The prefix is too broad, though: the secret store password check uses
// "420005ec-..." ids, so every successful unlock was read as a credential having
// just been created and fired two needless requests. Matching the exact ids we
// sent, normalised, removes both the collision and the reason for the prefix.
const sentSecretRequestIds = new Set();
const MAX_TRACKED_SECRET_REQUESTS = 50;

export const trackSecretRequest = (id) => {
    sentSecretRequestIds.add(`${id}`.toLowerCase());

    while (sentSecretRequestIds.size > MAX_TRACKED_SECRET_REQUESTS) {
        sentSecretRequestIds.delete(sentSecretRequestIds.values().next().value);
    }

    return id;
};

export const isSecretRequestReply = (id) => sentSecretRequestIds.has(`${id}`.toLowerCase());

function secretCreated(secretCreateID) {
    let returnValue = false;

    window.createdSecrets.map((el) => {
        if (el == secretCreateID.toLowerCase()) {
            returnValue = true;
        }
    });

    return returnValue;
}

const titleExplain = {
    "root_user": "Run scan using root user (default)",
    "login_user": "Run scan using login user. No sudo or su will be used",
    "custom": "Run scan using custom user. You can specify the user to run the scanner as"
}

const STRING_CUSTOM_USER_NAME = "Custom username";
const STRING_EMPTY = "";
const STRING_USERNAME = "Username";
const STRING_ROOT_PASSWORD = "root password";
const STRING_LOGIN_PASSWORD = "Password for login user";
const STRING_CUSTOM_PASSWORD = "Custom Password";
const debuugEnabled = false;
const enableDebugConsole = window.extendedLog;
const createTimeoutValue = 1000;

const ra_userName = {
    "username_password": {
        "root_user": {
            "sudo": STRING_EMPTY,
            "su": "root username",
        },
        "login_user": {
            "sudo": STRING_EMPTY,
            "su": STRING_EMPTY,
        },
        "custom": {
            "sudo": STRING_CUSTOM_USER_NAME,
            "su": STRING_CUSTOM_USER_NAME,
        }
    },
    "private_key": {
        "root_user": {
            "sudo": STRING_USERNAME,
            "su": STRING_USERNAME,
        },
        "login_user": {
            "sudo": STRING_EMPTY,
            "su": STRING_EMPTY,
        },
        "custom": {
            "sudo": STRING_CUSTOM_USER_NAME,
            "su": STRING_CUSTOM_USER_NAME
        }
    }
}

const ra_passwordName = {
    "username_password": {
        "root_user": {
            "sudo": STRING_EMPTY,
            "su": STRING_ROOT_PASSWORD,
        },
        "login_user": {
            "sudo": STRING_EMPTY,
            "su": STRING_EMPTY,
        },
        "custom": {
            "sudo": STRING_CUSTOM_PASSWORD,
            "su": STRING_CUSTOM_PASSWORD,
        }
    },
    "private_key": {
        "root_user": {
            "sudo": STRING_LOGIN_PASSWORD,
            "su": STRING_ROOT_PASSWORD,
        },
        "login_user": {
            "sudo": STRING_EMPTY,
            "su": STRING_EMPTY,
        },
        "custom": {
            "sudo": STRING_LOGIN_PASSWORD,
            "su": STRING_CUSTOM_PASSWORD,
        }
    }
}

const GroupHeader = styled('div')(({ theme }) => ({
    fontSize: "12px",
    position: 'sticky',
    // top: '-8px',
    padding: '4px',
    paddingBottom: '0px',
    paddingTop: '6px',
    marginLeft: "10px",
    textDecoration: "underline",
    // textDecorationColor: `${colorHashiCorpVault}2A`,
    textDecorationColor: `rgba(255,255,255,0.1)`,
    // color: "rgba(255,255,255,0.84)",
    color: `${colorHashiCorpVault}`,
    ...theme.applyStyles('dark',
        {
            '&:hover': {
                // backgroundColor: hoverColor,
            },
            backgroundColor: "rgba(255,255,255,0.)",
        }),
}));

const GroupItems = styled('ul')({
    // color:"red",
    listStyleType: "none",
    padding: 0,
    paddingLeft: "4px",
});


export function HashiAutocomplete({ optionsList, userPath = "", setUserPath = false, tabIndex = 0, name = "hashiAutocomplete", top = -19, bottom = 10, widthAdjust = 0, pointerEvents = "all" }) {

    const options = optionsList?.map((option) => {
        const parentName = option?.attr?.[0]?.toUpperCase();
        return {
            parentName: /[0-9]/.test(parentName) ? '0-9' : parentName,
            ...option,
        };
    }) || [];

    const onChangeHandler =
        (event, value) => {
            event.target.setAttribute("data-id", value?.uid);

            setSelectedValue(value);
            setTypeValue(`${value?.label || value?.value || value?.attr} || ""`);
            if (setUserPath) {
                setUserPath("");
                if (value && value.prefixName) {
                    setTimeout(() => {
                        setUserPath(value.uid);
                    }, 20);
                }

            }
        }


    useEffect(() => {
        if (name == "ra_scan_username_hv") {
            try {
                //   let allParents = optionsList?.map(op => op.parentName);
                //   allParents = allParents.filter((value, index, self) => self.indexOf(value) === index)
                //   if (allParents?.length == 1) {
                //       setTimeout(() => {
                //         let rootUserField = optionsList.find(op => op.value == optionsList[0].rootUserField);
                //           onChangeHandler(null, rootUserField );
                //       }, 20);

                //   }
            } catch (e) { }
        }
    }, [])

    const [selectedValue, setSelectedValue] = useState(
        (name == "scan_password" || name == "ra_scan_password_hvq") ?
            options?.
                filter(op => {
                    let retval = false;

                    if (userPath == "") {
                        retval = true;
                    }

                    if (op.uid == userPath) {
                        retval = false;
                    } else {
                        if (JSON.stringify(op).toLowerCase().includes(userPath.split("#")[0].toLowerCase())) {
                            retval = true;
                        }
                    }
                    return retval;
                }).sort((a, b) => -a?.uid?.localeCompare(b?.uid))[0]
            :
            null

    );

    const [typeValue, setTypeValue] = useState(selectedValue?.label || selectedValue?.value || selectedValue?.attr || "");
    const isLdap = (userPath.length > 0 && userPath.indexOf("vault+ldap:") == 0)

    if (isLdap) {
        return (
            <div></div>
        )
    }
    return (
        <>
            <Autocomplete
                disableListWrap
                // disableCloseOnSelect
                freeSolo
                autoHighlight
                className="add-credential hashiAutocomplete"
                style={{
                    pointerEvents: pointerEvents,
                    fontSize: "14px !important",
                    minWidth: `calc(100% - ${widthAdjust}px)`,
                    maxHeight: "22px",
                    minHeight: "22px",
                    height: "22px",
                    marginLeft: "16px",
                    marginTop: `${top}px`,
                }}
                value={(isLdap) ? userPath : selectedValue}
                options={options?.
                    filter(op => {
                        let retval = false;

                        if (userPath == "") {
                            retval = true;
                        }

                        if (op.uid == userPath) {
                            retval = false;
                        } else {
                            if (JSON.stringify(op).toLowerCase().includes(userPath.split("#")[0].toLowerCase())) {
                                retval = true;
                            }
                        }

                        return retval;
                    }).
                    sort((a, b) => -a?.uid?.localeCompare(b?.uid)) || []
                }
                groupBy={(option) => option.parentName}
                getOptionLabel={(option) => `${option.label || option.value || option.attr}`}
                filterOptions={(options, state) => {
                    const filteredOptions = options.filter(op => JSON.stringify(op).toLowerCase().indexOf(state.inputValue.toLowerCase()) !== -1);
                    return filteredOptions;
                }}
                onChange={onChangeHandler}
                renderOption={(props, option, state, ownerState) => {
                    const { key, ...optionProps } = props;
                    return (
                        <li {...optionProps} key={key} className="hashiLi" style={{ listStyleType: "none" }} >
                            {option.attr}
                        </li>
                    )
                }}
                renderGroup={(params) => (
                    <li key={params.key} className="hashiLiG">
                        <GroupHeader>{params.group}</GroupHeader>
                        <div style={{ pointerEvents: "none", position: "absolute", marginTop: "-15px", marginLeft: "5px", transform: "scale(0.42)" }}>{ICON_HASHICORP_VAULT}</div>
                        <GroupItems>{params.children}</GroupItems>
                    </li>
                )}

                renderInput={(params) => {
                    if (isLdap) {
                        return (
                            <TextField
                                className="add-credential"
                                {...params}
                                id={name}
                                name={name}
                                onChange={(e) => {
                                    setTypeValue(e.target.value);
                                }}
                                autoComplete={'one-time-code'}
                            />)
                    }

                    params.inputProps.tabIndex = tabIndex;
                    return (
                        <TextField
                            className="add-credential"
                            {...params}
                            id={name}
                            name={name}
                            onChange={(e) => {
                                setTypeValue(e.target.value);
                            }}
                            autoComplete={'one-time-code'}
                        />)
                }
                }
            />
            <div
                style={{
                    // float:"right",
                    marginLeft: 25,
                    position: "relative",
                    width: "calc(100% - 45px)",
                    height: "1px",
                    pointerEvents: "none",
                }}
            >
                <div
                    data-name={name}
                    data-id={selectedValue?.uid}

                    style={{
                        textAlign: "right",
                        position: "absolute",
                        marginTop: "27px",
                        ...(widthAdjust > 0 ? { marginRight: `${widthAdjust}px` } : {}),
                        letterSpacing: "-0.42px",
                        right: "0px",
                        transform: "scale(0.62)",
                        transformOrigin: "right top",
                        color: "rgba(255, 255, 255,0.124)"
                    }}>{selectedValue?.uid || ""}</div>
            </div>
            <div style={{ pointerEvents: "none", position: "absolute", marginTop: "-5px", marginLeft: "38px", transform: "scale(1)" }}>{ICON_HASHICORP_VAULT}</div>
            {typeValue && typeValue?.indexOf("#") !== -1 &&
                <div
                    className="yellowMask"
                    style={{
                        pointerEvents: "none",
                        position: "absolute", marginTop: "-1.4px", marginLeft: "52px",
                        // backgroundColor:colorHashiCorpVault,
                        fontSize: "14.4px",
                        color: "rgb(44, 43, 42)", padding: "0", borderRadius: "0 4px 4px 0px"
                    }}>
                    <div>{selectedValue?.label.split("#")[0] || ""}</div>
                    <div style={{
                        width: "100%",
                        fontSize: "12px",
                        fontStyle: "italic",
                        font: "bold",
                        letterSpacing: "0.042px",
                        textAlign: "center",
                        marginLeft: "-4px",
                        color: "rgba(0,0,0,1)",
                        marginTop: "-16px", position: "absolute"
                    }}>{selectedValue?.label.split("#")[0] || ""}</div>

                </div>}

        </>
    )
}

function AddCredential(props) {
    const formControlRef = useRef();
    const localSecret = window._g.localSecret;
    const protocolTypes = [`ssh`, `winrm`, `aws-ssm`];
    const credTypes = [`username_password`, `private_key`];
    const runScanTypes = [`root_user`, `login_user`, `custom`];
    const sudoORSuTypes = [`sudo`, `su`];
    const [sudoORSu, setSudoORSu] = useState(sudoORSuTypes[0]);

    const hiddenFieldOpa = 0;
    const [runAsType, setRunAsType] = useState(runScanTypes[0]);
    const [credName, setCredName] = useState("");
    const [lastCreatedRef, setLastCreatedRef] = useState("");
    const showOptional = true;
    const [credType, setCredType] = useState(credTypes[0]);
    const [errorText, setErrorText] = useState("");
    const [enableAdd, setEnableAdd] = useState(true);
    const [saveName, setSaveName] = useState("Save credential");
    const [port, setPort] = useState(22);
    const [domain, setDomain] = useState(null);
    const [regionVal, setRegionVal] = useState("");
    const [protocol, setProtocol] = useState(sessionStorage.lastProtocolType || protocolTypes[0]);
    const [customUsernameString, setCustomUsernameString] = useState("");

    const [optionsList, setOptionsList] = useState([]);


    const disable1 = (runAsType == runScanTypes[1]);
    const disable2 = (sudoORSu == sudoORSuTypes[0] && runAsType == runScanTypes[0] && credType == credTypes[0]);
    const disable3 = (runAsType == runScanTypes[2] || credType == credTypes[0] && sudoORSu == sudoORSuTypes[0]) &&
        (runAsType != runScanTypes[2] && sudoORSu != sudoORSuTypes[1]);

    const handleClose = () => {
        setErrorText("");
        setCustomUsernameString("");
        props.setOpen(false);
    };

    const handleChange = (event) => {
        let newProtocol = event.target.value;

        window.postMessage(
            JSON.stringify({
                type: APPFACTOR.command,
                scanRaw: true,
                payload: {
                    "secret_type": "username_password",
                    "type": "get_secrets",
                    "id": "88888888-4444-4444-1111-121212121212",
                    "store_password": localSecret,
                }
            })
        );

        setProtocol(newProtocol);
        sessionStorage.lastProtocolType = event.target.value;
        setCredType(credTypes[0]);
        setDomain("");
        setPort(22);
    };

    function processIncomming(event) {
        try {
            let eventData = {
                ...(typeof event.data !== 'undefined') ? JSON.parse(event.data) : {},
            };

            if (isSecretRequestReply(eventData.id)) {
                if (eventData.completed && eventData.success) {
                    window.createdSecrets.push(eventData.id);
                    window.postMessage(
                        JSON.stringify({
                            type: APPFACTOR.command,
                            scanRaw: true,
                            payload: {
                                "secret_type": window._g.credType == "username_password" ? window._g.credType : "ssh_key",
                                "type": "get_secrets",
                                "id": "88888888-4444-4444-1111-121212121212",
                                "store_password": window._g.localSecret,
                            }
                        })
                    );

                    window.postMessage(
                        JSON.stringify({
                            type: APPFACTOR.command,
                            scanRaw: true,
                            payload: {
                                "type": "get_protocols",
                                "id": newSessionUID(),
                                "store_password": window._g.localSecret,
                            }
                        })
                    );
                }
            }
        } catch (e) { /* */ }
    }

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.shiftKey && e.altKey) {
                setSaveName(p => {
                    if (p == "Save credential") {
                        return "Save and new";
                    } else {
                        return "Save credential";
                    }
                })
            }
        };

        document.addEventListener('keydown', handleKeyDown, true);
        window.addEventListener("message", processIncomming, false);
        window.createdSecrets = [];

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener("message", processIncomming, false);
        };
    }, []);

    useEffect(() => {
        if (props.open) {
            setProtocol(sessionStorage.lastProtocolType || protocolTypes[0]);
            window._g.credType = credType;

            window.postMessage(
                JSON.stringify({
                    type: APPFACTOR.command,
                    scanRaw: true,
                    payload: {
                        "secret_type": credType == "username_password" ? credType : "ssh_key",
                        "type": "get_secrets",
                        "id": newSessionUID(),
                        "store_password": localSecret,
                    }
                })
            );

            window.postMessage(
                JSON.stringify({
                    type: APPFACTOR.command,
                    scanRaw: true,
                    payload: {
                        "type": "get_protocols",
                        "id": newSessionUID(),
                        "store_password": localSecret,
                    }
                })
            );
        }
    }, [props.open]);



    const [isStandard, setIsStandard] = useState(localStorage.getItem("defaultCredStandard") ? localStorage.getItem("defaultCredStandard") == "true" ? true : false : true);
    const supportedEngines = ["kv", "ldap", "ssh"];
    const [userPath, setUserPath] = useState("");
    const [userPathRa, setUserPathRa] = useState("");

    const [engines, setEngines] = useState(
        supportedEngines.map(en => ({ [en]: [] })).reduce((acc, curr) => ({ ...acc, ...curr }), {})
    );

    const [vaultExistingNamespaces, setVaultExistingNamespaces] = useState([])

    const supportedStoreNames = ["kv", "ldap", "ssh"];

    useEffect(() => {
        if (props.open && !isStandard) {
            let optionsList = [];

            if (protocol == protocolTypes[0] && credType == credTypes[0]) {
                let userStores = [
                    supportedStoreNames[0],
                    supportedStoreNames[1]
                ];

                // password
                userStores.map(storeName => {

                    engines[storeName].map(en => {
                        let urlList = `${hashicorpVaultSettings?.url}/v1/${en.path}metadata/?list=true`;
                        let staticADList = "";

                        if (storeName == supportedStoreNames[1]) {
                            // urlList is the dynamoc ad role list
                            urlList = `${hashicorpVaultSettings?.url}/v1/${en.path}role?list=true`;
                            staticADList = `${hashicorpVaultSettings?.url}/v1/${en.path}static-role?list=true`;
                        }

                        if (!window._g.hashiCache) {
                            window._g.hashiCache = {};
                        }

                        if (window._g.hashiCache[urlList]) {
                            console.log("cache hit", en.path, window._g.hashiCache[urlList])
                        } else {
                            const vaultHeaders = {
                                "X-Vault-Token": hashicorpVaultSettings?.token || hashicorpVaultToken
                            }

                            if (hashicorpVaultSettings?.namespace) {
                                vaultHeaders["X-Vault-Namespace"] = hashicorpVaultSettings.namespace;
                            }

                            function processKVList(zData, storeName) {
                                const vaultHeaders = {
                                    "X-Vault-Token": hashicorpVaultSettings?.token || hashicorpVaultToken
                                }

                                if (hashicorpVaultSettings?.namespace) {
                                    vaultHeaders["X-Vault-Namespace"] = hashicorpVaultSettings.namespace;
                                }

                                if (window.extendedLog) { console.log("zData = ", zData); }
                                try {
                                    zData.data.keys.map(key => {
                                        if(!key.endsWith("/")){

                                        let dataUrl = `${hashicorpVaultSettings?.url}/v1/${en.path}data/${key}`;
                                        if (storeName == "cubbyhole") {
                                            dataUrl = `${hashicorpVaultSettings?.url}/v1/${en.path}${key}`;
                                        }
                                        fetch(dataUrl, {
                                            method: "GET",
                                            headers: vaultHeaders
                                        })
                                            .then(res => res.json())
                                            .then(zData2 => {
                                                window._g.hashiCache[dataUrl] = zData2;
                                                if (window.extendedLog) { console.log(`zData2 = ${dataUrl}`, zData2); }
                                                let dataPath = zData2?.data?.data || zData2?.data;

                                                Object.keys(dataPath).map(k => {
                                                    // vault+kv:/kv/creds/servers/linux#admin_user,admin_password
                                                    let VAULT_KV = `vault+${storeName}:/`;
                                                    let rootUserField = "";
                                                    try {
                                                        rootUserField = Object.keys(dataPath).map(rf => dataPath[rf] == "root" ? rf : "").filter(rf => rf.length > 0);
                                                        // console.log("rootUserField", rootUserField)
                                                    } catch (e) { }
                                                    let optionData = {
                                                        attr: k,
                                                        uid: `${VAULT_KV}${en.path}${key}#${k}`,
                                                        parentName: `${en.path}${key}`,
                                                        prefixName: `${VAULT_KV}${en.path}${key}`,
                                                        value: `${k}`,
                                                        label: `${en.path}${key}#${k}`,
                                                        isUserRoot: JSON.stringify(dataPath).indexOf(`"root"`) !== -1 ? true : false,
                                                        rootUserField: rootUserField
                                                    }
                                                    setOptionsList(prev => {
                                                        let newData = [...prev];
                                                        let index = newData.findIndex(item => item.uid === optionData.uid);
                                                        if (index === -1) {
                                                            newData.push(optionData);
                                                        } else {
                                                            newData[index] = optionData;
                                                        }

                                                        return newData;
                                                    });
                                                })
                                            })
                                            .catch(err => {
                                                if (window.extendedLog) { console.error("Failed to fetch data:", err); }
                                            });
                                        }
                                    })
                                } catch (e) {
                                    /* */
                                }
                            }

                            function processADList(zData, storeName, mainPath) {

                                const vaultHeaders = {
                                    "X-Vault-Token": hashicorpVaultSettings?.token || hashicorpVaultToken
                                }

                                if (hashicorpVaultSettings?.namespace) {
                                    vaultHeaders["X-Vault-Namespace"] = hashicorpVaultSettings.namespace;
                                }

                                if (window.extendedLog) { console.log("zData = ", zData); }
                                try {
                                    let VAULT_KV = `vault+${storeName}:/`;

                                    zData.data.keys.map(key => {
                                        //    console.log("AD - key = ", key);
                                        let optionData = {
                                            attr: key,
                                            uid: `${VAULT_KV}${mainPath}${en.path}${key}`,
                                            parentName: `${mainPath}${en.path}${key}`,
                                            prefixName: `${VAULT_KV}${mainPath}${en.path}${key}`,
                                            value: `${key}`,
                                            label: `${mainPath}${en.path}#${key}`,
                                            isDynamic: mainPath == "dynamic/" ? true : false,
                                        }

                                        // console.log("optionData = ", optionData);

                                        setOptionsList(prev => {
                                            let newData = [...prev];
                                            let index = newData.findIndex(item => item.uid === optionData.uid);
                                            if (index === -1) {
                                                newData.push(optionData);
                                            } else {
                                                newData[index] = optionData;
                                            }

                                            return newData;
                                        });
                                    })
                                } catch (e) {
                                    console.log("processADList error = ", e);
                                }
                            }

                            fetch(urlList, {
                                method: "GET",
                                headers: vaultHeaders
                            })
                                .then(res => res.json())
                                .then(zData => {
                                    if (storeName == supportedStoreNames[0]) {
                                        processKVList(zData, storeName);
                                    } else if (storeName == supportedStoreNames[1]) {
                                        processADList(zData, storeName, "dynamic/");
                                    }
                                })
                                .catch(err => {
                                    if (window.extendedLog) { console.error("Failed to fetch list of keys:", err); }
                                });

                            if (staticADList.length > 0) {
                                fetch(staticADList, {
                                    method: "GET",
                                    headers: vaultHeaders
                                })
                                    .then(res => res.json())
                                    .then(zData => {
                                        processADList(zData, storeName, "static/");
                                    })
                                    .catch(e => {
                                        console.log("processADList error = ", e);
                                    });
                            }

                        }

                    })
                })


                // } else if( data?.type == "cubbyhole" ){
                //     urlList = `${hashicorpVaultSettings?.url}/v1/${mountPath}%2F/?list=true`;
                // }



                // engines.kv.map(e => ({ attr: e.path,parentName: "kv",value: `${e.path}` }))
                optionsList = []
                // 
            } else if (protocol == protocolTypes[0] && credType == credTypes[1]) {
                //ssh

            } else if (protocol == protocolTypes[1]) {
                // winrm
                optionsList = []

            }

            try {
                Object.keys(engines).map(en => {
                    try {
                        if (window.extendedLog) { console.log(engines[en].map(e => ({ attr: e.path, parentName: en.type, value: `${en.type}:${e.path}` }))); }
                        return engines[en].map(e => ({ attr: e.path, parentName: en.type, value: `${en.type}:${e.path}` }))
                    } catch (e) { }
                    // console.log(engines[en])
                })
                    .flat()
            } catch (e) { }
            // if(optionsList.length > 0){
            //     setOptionsList(optionsList);
            // }
            // en.map(e => ({ attr: e.path,parentName: en.type,value: `${en.type}:${e.path}` }))).flat()

        }
    }, [engines, props.open, isStandard])

    const [hashicorpVaultSettings, setHashicorpVaultSettings] = useState(
        localStorage.getItem("hashicorpVaultSettings") ? JSON.parse(localStorage.getItem("hashicorpVaultSettings")) : {})

    const hashiAuthTypes = ["approle", "token"];

    const [hashiAuthType, setHashiAuthType] = useState(hashicorpVaultSettings?.type || hashiAuthTypes[0]);

    const hashiVaultUrl = `${hashicorpVaultSettings?.url}/v1/auth/${hashicorpVaultSettings?.approle}/login`;

    const [hashicorpVaultToken, setHashicorpVaultToken] = useState(null);
    const [response, setResponse] = useState("");
    const [openHashSettings, setOpenHashSettings] = useState(false);
    const getSecretsList = (data, mountPath) => {
        const vaultHeaders = {
            "X-Vault-Token": hashicorpVaultSettings?.token || hashicorpVaultToken
        }

        if (hashicorpVaultSettings?.namespace) {
            vaultHeaders["X-Vault-Namespace"] = hashicorpVaultSettings.namespace;
        }

        if (supportedEngines.includes(data?.type)) {
            fetch(`${hashicorpVaultSettings?.url}//v1/sys/internal/ui/mounts/${mountPath}`, {
                method: "GET",
                headers: vaultHeaders
            })
                .then(res => res.json())
                .then(zData => {
                    setEngines(prev => {
                        let prevValues = prev[zData?.data?.type];
                        return {
                            ...prev,
                            [zData?.data?.type]: prevValues.concat(zData.data)
                        }
                    })
                })
                .catch(err => {
                    console.error("Failed to fetch Vault keys:", err);
                });
        }

        return;
    }

    const getMountsList = () => {
        const vaultHeaders = {
            "X-Vault-Token": hashicorpVaultSettings?.token || hashicorpVaultToken
        }

        if (hashicorpVaultSettings?.namespace) {
            vaultHeaders["X-Vault-Namespace"] = hashicorpVaultSettings.namespace;
        }

        fetch(`${hashicorpVaultSettings?.url}/v1/sys/internal/ui/namespaces`,
            {
                method: "GET",
                headers: vaultHeaders
            }).then(response => response.json())
            .then(data => {
                // let data = { data: { keys: ["ns.prod1", "ns.dev1","ns.dev1","ns.dev1","ns.dev1","ns.dev1","ns.dev1", "ns.test1"] } }
                try {
                   

                    
                    setVaultExistingNamespaces(prev => {
                        let newNamespaces = [...prev];
                        
                        data.data.keys.map(key => {
                            if( key.length > 0 ){
                                newNamespaces.push(key);
                            }
                        })
    
                        newNamespaces = newNamespaces.filter((value, index, self) => self.indexOf(value) === index)
                        
                        return newNamespaces;
                    })

                } catch (e) {
                    console.log("getMountsList error", e)
                }
            })
            .catch(error => {
                // console.log("getMountsList error", error)
            })

        fetch(
            `${hashicorpVaultSettings?.url}/v1/sys/internal/ui/mounts`,
            {
                method: "GET",
                headers: vaultHeaders
            }).then(response => response.json())
            .then(data => {
                if (data && data.data && data.data.secret) {
                    const allVaultKeys = Object.keys(data.data.secret);
                    allVaultKeys.forEach(key => {
                        getSecretsList(data.data.secret[key], key);
                    });
                } else {
                    console.warn("No secrets found in vault response", data);
                }
            })
            .catch(error => {
                console.log("getMountsList error", error)
            })
    }

    const [loginFinished, setLoginFinished] = useState(false);
    const FAILED_CHECK_URL_CERTIFICATE = "Failed to fetch. \t◦    Please check that the URL and certificate are valid, and try again.";
    useEffect(() => {
        // Check if all properties of hashicorpVaultSettings have non-empty values
        const allSettingsHaveValue = hashicorpVaultSettings &&
            typeof hashicorpVaultSettings === 'object' &&
            Object.values(hashicorpVaultSettings).every(
                v => typeof v === 'string' && v.length > 0
            ) &&
            Object.keys(hashicorpVaultSettings).length > 0;

        setLoginFinished(false);

        const vaultHeaders = {
            "X-Vault-Token": hashicorpVaultSettings?.token || hashicorpVaultToken
        }

        if (hashicorpVaultSettings?.namespace) {
            vaultHeaders["X-Vault-Namespace"] = hashicorpVaultSettings.namespace;
        }

        if (!isStandard && allSettingsHaveValue && isValidUrl(hashicorpVaultSettings?.url)) {
            if (hashicorpVaultSettings?.type == "approle") {
                fetch(hashiVaultUrl, {
                    method: "POST",
                    body: JSON.stringify({
                        "role_id": hashicorpVaultSettings?.role_id,
                        "secret_id": hashicorpVaultSettings?.secret_id,
                    }),
                })
                    .then(response => {
                        setLoginFinished(true);
                        if (response.status == 200) {
                            return response.json()
                        } else {
                            setHashicorpVaultToken(null)
                            return response.json()
                        }
                    })
                    .then(data => {
                        if (openHashSettings) {
                            setResponse(data)
                        }

                        if (Object.keys(data).length > 0) {
                            let setToken = data?.auth?.client_token;
                            setHashicorpVaultToken(setToken);
                            window._g.hashicorp_vault_token = setToken;
                        } else {
                            setHashicorpVaultToken(null)
                        }
                    })
                    .catch(error => {
                        setLoginFinished(true);
                        if (error.message == "Failed to fetch") {
                            setResponse({ errors: [FAILED_CHECK_URL_CERTIFICATE], checkURL: hashicorpVaultSettings?.url })
                        } else {
                            setResponse(error.message)
                        }

                        setHashicorpVaultToken(null)
                    }).finally(() => {
                        setLoginFinished(true);
                    })
            } else {

                fetch(
                    `${hashicorpVaultSettings?.url}/v1/sys/internal/ui/mounts`,
                    {
                        method: "GET",
                        headers: vaultHeaders
                    })
                    .then(response => {
                        setLoginFinished(true);

                        if (response.status == 200) {
                            setHashicorpVaultToken(hashicorpVaultSettings.token)
                            window._g.hashicorp_vault_token = hashicorpVaultSettings.token;

                            return response.json()
                        } else {
                            setHashicorpVaultToken(null)
                            return response.json()
                        }
                    })
                    .then(data => {
                        if (openHashSettings) {
                            setResponse(data)
                        }

                    })
                    .catch(error => {
                        setLoginFinished(true);
                        console.log("error", error)
                        if (error.message == "Failed to fetch") {
                            setResponse({ errors: [FAILED_CHECK_URL_CERTIFICATE], checkURL: hashicorpVaultSettings?.url })
                        } else {
                            setResponse(error.message)
                        }
                        setHashicorpVaultToken(null)
                    })

            }
        }
    }, [openHashSettings, isStandard, setHashicorpVaultToken, hashicorpVaultSettings])


    useEffect(() => {
        if (props.open && !isStandard && hashicorpVaultToken) {
            // console.log("getMountsList", 
            getMountsList()
            // )
        }
    }, [hashicorpVaultToken, props.open, isStandard])

    useEffect(() => {
        if (protocol == protocolTypes[2]) {
            setUserPath("")
        }
    }, [protocol])

    const showPasswordRA = runAsType != runScanTypes[2] || (runAsType == runScanTypes[2] && sudoORSu == sudoORSuTypes[0]);
    const showUsernameRA = runAsType != runScanTypes[2] || (runAsType == runScanTypes[2] && sudoORSu == sudoORSuTypes[1]);

    return (<>
        <Dialog
            className="add-credential-dialog"
            style={{
                backdropFilter: "blur(4.2px)",
                background: "rgba(255,255,255,0.1)",
                height: "100%"
            }}
            // fullWidth={true}

            open={props.open}
            onClose={handleClose}

            slotProps={{
                paper: {
                    tabIndex: -1,
                    className: "niceBorder animateBorder",
                    sx: {
                        width: "942px",
                        maxWidth: "942px",
                        minWidth: "942px",
                        opacity: 1,
                        paddingBottom: "20px",
                        backgroundColor: "black",
                        background: "linear-gradient(174.69deg, #202020 2.73%, #321B17 94.22%)",//"rgba(32,32,32,1)
                        maxHeight: "742px",
                        height: "100%",
                        minHeight: "582px ",
                        paddingTop: "6px",
                        overflow: "visible",
                    },

                    component: "form",
                    onSubmit: (event) => {
                        // event.preventDefault();
                        document.querySelector(".scanButton[type='submit']").classList.add("disabled");
                        event.preventDefault();

                        if (props.existingProtocols.includes(credName)) {
                            setErrorText("Credential name already exists.");
                            document.querySelector(".scanButton[type='submit']").classList.remove("disabled");

                            return;
                        }

                        let theSecretName = uuidv4();
                        let secretCreateID = "";
                        let suSecretKey = uuidv4();
                        let additionalWaitFOrCredential = []

                        function createCredential() {
                            let returnValue = true;
                            setErrorText("");

                            const formData = new FormData(formControlRef.current.parentNode);
                            const formJson = Object.fromEntries((formData).entries());

                            formJson.scan_secretName = theSecretName;
                            setLastCreatedRef(formJson.scan_secretName);

                            if (formJson.scan_secretName.length > 0) {
                                if (formJson.scan_username?.length == 0) {
                                    setErrorText("Username missing.");

                                    return false;
                                }

                                if (protocol != protocolTypes[2]) {
                                    if (props.secretsList.includes(formJson.scan_secretName)) {
                                        setErrorText("Secret already exists");

                                        return false;
                                    } else {

                                        //winrm .... 
                                        if (credType == credTypes[0]) {
                                            if (formJson.scan_username.length == 0) {
                                                setErrorText("Password is empty");

                                                return false;
                                            }

                                            if (formJson.scan_password.length == 0) {
                                                setErrorText("Password is empty")

                                                return false;
                                            }

                                            let rID = trackSecretRequest("42000001-f00d-face-babe-DDCCBBAA" + (Math.floor(Math.random() * (9999 - 1000 + 1) + 1000)));
                                            secretCreateID = rID;
                                            let payload = {
                                                "type": "add_secret",
                                                "id": rID,
                                                "secret_key": `${formJson.scan_secretName}`,
                                                "store_password": localSecret,
                                                "secret": {
                                                    "type": `${formJson.credType}`,
                                                    "user_name": `${formJson.scan_username}`,
                                                    "password": `${formJson.scan_password}`
                                                }
                                            }




                                            if (protocol == protocolTypes[1]) {
                                                try {
                                                    let domainVal = formJson["scan_domain"];

                                                    if (domainVal && domainVal != "") {
                                                        payload.secret.domain = domainVal;
                                                    }
                                                } catch (e) { /**/ }

                                                try {
                                                    let connTimeout = formJson["conn_timeout"];

                                                    if (connTimeout && connTimeout != "5s") {
                                                        payload.conn_timeout = connTimeout;
                                                    }
                                                } catch (e) {/**/ }
                                            }

                                            if (protocol == protocolTypes[0]) {
                                                if (runAsType != runScanTypes[1] &&
                                                    !(runAsType == runScanTypes[0] && sudoORSu == sudoORSuTypes[0]) &&
                                                    !(runAsType == runScanTypes[2] && sudoORSu == sudoORSuTypes[0])
                                                ) {
                                                    if (enableDebugConsole) console.log("formJson", formJson)
                                                    if (enableDebugConsole) console.log("create sudo_password_secret_ref")
                                                    let rIDsudo = trackSecretRequest("42000001-f00d-face-babe-DDCCBBAA" + (Math.floor(Math.random() * (9999 - 1000 + 1) + 1000)));
                                                    let payloadsu = {
                                                        "type": "add_secret",
                                                        "id": rIDsudo,
                                                        "secret_key": suSecretKey,
                                                        "store_password": localSecret,
                                                        "secret": {
                                                            "type": `username_password`,
                                                            "user_name": `${formJson.ra_scan_username}`,
                                                            "password": `${formJson.ra_scan_password}`
                                                        }
                                                    }

                                                    if (enableDebugConsole) console.log("create sudo_password_secret_ref payload", payloadsu)

                                                    additionalWaitFOrCredential.push(rIDsudo);

                                                    window.postMessage(
                                                        JSON.stringify({
                                                            type: APPFACTOR.command,
                                                            scanRaw: true,
                                                            payload: payloadsu
                                                        })
                                                    );
                                                } else {
                                                    if (enableDebugConsole) console.log("NOT CREATE -  sudo_password_secret_ref")
                                                }
                                            }



                                            if (additionalWaitFOrCredential.length == 0) {
                                                window.postMessage(
                                                    JSON.stringify({
                                                        type: APPFACTOR.command,
                                                        scanRaw: true,
                                                        payload: payload
                                                    })
                                                );
                                            }
                                            else {

                                                let waitingSecretCreation = setInterval(() => {
                                                    let created = additionalWaitFOrCredential.every(f => secretCreated(f))
                                                    if (created) {
                                                        clearInterval(waitingSecretCreation);

                                                        if (enableDebugConsole) console.log("create create secret", payload)
                                                        window.postMessage(
                                                            JSON.stringify({
                                                                type: APPFACTOR.command,
                                                                scanRaw: true,
                                                                payload: payload
                                                            })
                                                        );
                                                    }
                                                }, createTimeoutValue);



                                            }


                                        }
                                        else {
                                            let rID = trackSecretRequest("42000001-f00d-face-babe-DDCCBBBB" + (Math.floor(Math.random() * (9999 - 1000 + 1) + 1000)));
                                            secretCreateID = rID;
                                            if (formJson.key_data.length == 0) {
                                                setErrorText("Key Data is empty")
                                                return false;
                                            }


                                            if (protocol == protocolTypes[0]) {
                                                if (runAsType != runScanTypes[1]) {
                                                    if (enableDebugConsole) { console.log("formJson", formJson) }
                                                    if (enableDebugConsole) { console.log("create sudo_password_secret_ref") }
                                                    let rIDsudo = trackSecretRequest("42000001-f00d-face-babe-DDCCBBAA" + (Math.floor(Math.random() * (9999 - 1000 + 1) + 1000)));
                                                    let payloadsu = {
                                                        "type": "add_secret",
                                                        "id": rIDsudo,
                                                        "secret_key": suSecretKey,
                                                        "store_password": localSecret,
                                                        "secret": {
                                                            "type": `username_password`,
                                                            "user_name": `${formJson.ra_scan_username}`,
                                                            "password": `${formJson.ra_scan_password}`
                                                        }
                                                    }

                                                    if (enableDebugConsole) console.log("create sudo_password_secret_ref payload", payloadsu)
                                                    additionalWaitFOrCredential.push(rIDsudo);

                                                    window.postMessage(
                                                        JSON.stringify({
                                                            type: APPFACTOR.command,
                                                            scanRaw: true,
                                                            payload: payloadsu
                                                        })
                                                    );
                                                } else {
                                                    if (enableDebugConsole) console.log("NOT CREATE -  sudo_password_secret_ref")
                                                }
                                            }

                                            let payloadF = {
                                                type: APPFACTOR.command,
                                                scanRaw: true,
                                                payload: {
                                                    "type": "add_secret",
                                                    "id": rID,
                                                    "secret_key": `${formJson.scan_secretName}`,
                                                    "store_password": localSecret,
                                                    "secret": {
                                                        "type": `ssh_key`,
                                                        "user_name": `${formJson.scan_username}`,
                                                        "data": `${formJson.key_data}`
                                                    }
                                                }
                                            }


                                            if (additionalWaitFOrCredential.length == 0) {
                                                if (enableDebugConsole) console.log("create create secret", payloadF)

                                                window.postMessage(
                                                    JSON.stringify(payloadF)
                                                );
                                            }
                                            else {

                                                let waitingSecretCreation = setInterval(() => {
                                                    let created = additionalWaitFOrCredential.every(f => secretCreated(f))
                                                    if (created) {
                                                        clearInterval(waitingSecretCreation);

                                                        if (enableDebugConsole) console.log("create create secret", payloadF)


                                                        window.postMessage(
                                                            JSON.stringify(payloadF)
                                                        );

                                                    }
                                                }, createTimeoutValue);
                                            }
                                        }
                                    }
                                } else {
                                    let rID = trackSecretRequest("42000001-f00d-face-babe-DDCCBBAA" + (Math.floor(Math.random() * (9999 - 1000 + 1) + 1000)));
                                    secretCreateID = rID;
                                    let payloadF = {
                                        "type": "add_secret",
                                        "id": rID,
                                        "secret_key": `${formJson.scan_secretName}`,
                                        "store_password": localSecret,
                                        "secret": {
                                            "type": `${formJson.credType}`,
                                            "user_name": `${formJson.scan_access_key}`,
                                            "password": `${formJson.scan_access_secret}`
                                        }
                                    }

                                    if (additionalWaitFOrCredential.length == 0) {
                                        window.postMessage(
                                            JSON.stringify({
                                                type: APPFACTOR.command,
                                                scanRaw: true,
                                                payload: payloadF
                                            })
                                        );
                                    }
                                    else {

                                        let waitingSecretCreation = setInterval(() => {
                                            let created = additionalWaitFOrCredential.every(f => secretCreated(f))
                                            if (created) {
                                                clearInterval(waitingSecretCreation);

                                                window.postMessage(
                                                    JSON.stringify({
                                                        type: APPFACTOR.command,
                                                        scanRaw: true,
                                                        payload: payloadF
                                                    })
                                                );
                                            }
                                        }, createTimeoutValue);
                                    }


                                }


                            } else {
                                returnValue = false;
                                setErrorText("Secret name invalid.")
                            }

                            return returnValue;
                        }

                        function createProtocol(event, currentTarget, currentSecret, suSecretKey, suSecretKeyName = "ra_scan_password") {
                            setErrorText("");

                            event.preventDefault();

                            const formData = new FormData(currentTarget);
                            const formJson = Object.fromEntries((formData).entries());

                            let error = '';
                            if (!formJson["credName"] || formJson["credName"].length == 0) {
                                error += "Credential name is invalid. ";
                            }

                            if (protocol == protocolTypes[2]) {
                                if (!formJson["scan_account_name"] || formJson["scan_account_name"].length == 0) {
                                    error += "Account name missing. ";
                                }

                                if (!formJson["scan_access_secret"] || formJson["scan_access_secret"].length == 0) {
                                    error += "Account access secret is missing. ";
                                }

                                if (!formJson["scan_access_key"] || formJson["scan_access_key"].length == 0) {
                                    error += "Account access key missing. ";
                                }

                                if ((regionVal || "").length == 0) {
                                    error += "Region missing. ";
                                }
                            }

                            if (protocol == protocolTypes[0] && credType == credTypes[1]) {
                                if (!formJson["scan_username"] || formJson["scan_username"].length == 0) {
                                    error += "SSH user name missing. ";
                                }
                            }

                            if (lastCreatedRef.length == 0) {
                                setErrorText("Please refresh and try again.");
                            }

                            if (error.length == 0) {
                                let addProtocol = {
                                    "store_password": localSecret,
                                    "type": "add_protocol",
                                    "id": trackSecretRequest("42000001-f00d-face-babe-DDCCBBAA" + (Math.floor(Math.random() * (9999 - 1000 + 1) + 1000))),
                                    "protocol_name": formJson["credName"],
                                    "protocol": protocol,
                                    "credentials": {
                                        "type": credType == credTypes[0] ? 'user_password' : 'private_key',
                                        "secret_ref": currentSecret
                                    }
                                };


                                if (protocol == protocolTypes[0]) {
                                    // password type
                                    if (credType == credTypes[0]) {
                                        if (sudoORSu == sudoORSuTypes[0]) {
                                            if (runAsType == runScanTypes[1]) {
                                                addProtocol.run_as_user = formJson.scan_username;
                                            } 
                                            // else {addProtocol.run_as_user = formJson[suSecretKeyName];}
                                        } else {
                                            if (runAsType == runScanTypes[0]) {
                                                // run_as_user not needed for this case ???
                                                addProtocol.su_instead_of_sudo = true;
                                                // addProtocol.run_as_user = formJson.runScanUsing;
                                                addProtocol.sudo_password_secret_ref = suSecretKey;
                                            } else if (runAsType == runScanTypes[1]) {
                                                // run_as_user not needed for this case
                                            } else {
                                                addProtocol.su_instead_of_sudo = true;
                                                addProtocol.run_as_user = formJson.ra_scan_username;
                                                addProtocol.sudo_password_secret_ref = suSecretKey;
                                            }
                                        }
                                    }
                                    // privateKey type
                                    else {
                                        if (sudoORSu == sudoORSuTypes[0]) {
                                            if (runAsType == runScanTypes[0]) {
                                                addProtocol.sudo_password_secret_ref = suSecretKey;
                                            } else if (runAsType == runScanTypes[1]) {
                                                addProtocol.run_as_user = formJson.scan_username;
                                            } else {
                                                addProtocol.sudo_password_secret_ref = suSecretKey;
                                                addProtocol.run_as_user = formJson.scan_username;
                                            }
                                        } else {
                                            if (runAsType == runScanTypes[0]) {
                                                addProtocol.su_instead_of_sudo = true;
                                                addProtocol.sudo_password_secret_ref = suSecretKey;
                                            } else if (runAsType == runScanTypes[1]) {
                                                addProtocol.run_as_user = formJson.scan_username;
                                            } else {
                                                addProtocol.su_instead_of_sudo = true;
                                                addProtocol.sudo_password_secret_ref = suSecretKey;
                                                addProtocol.run_as_user = formJson.ra_scan_username;
                                            }
                                        }
                                    }
                                }



                                // if(formJson.runScanUsing== "on" ){
                                //     addProtocol.su_instead_of_sudo = true;
                                //     addProtocol.sudo_password_secret_ref = suSecretKey;
                                // }

                                // if(formJson.run_as_user && formJson.run_as_user.length > 0){
                                //     addProtocol.run_as_user = formJson.run_as_user;
                                // }

                                if (credType == credTypes[1]) {
                                    addProtocol.credentials.user_name = formJson["scan_username"];
                                }

                                // aws-ssm
                                if (protocol == protocolTypes[2]) {
                                    if (formJson["scan_account_name"]) {
                                        addProtocol.credentials.account_name = formJson["scan_account_name"];
                                    }
                                    addProtocol.credentials.region = regionVal;
                                }

                                if (protocol == protocolTypes[1]) {
                                    try {
                                        let domainVal = formJson["scan_domain"];

                                        if (domainVal && domainVal != "") {
                                            addProtocol.credentials.domain = domainVal;
                                        }
                                    } catch (e) { /**/ }

                                    try {
                                        let conTimeout = formJson["conn_timeout"];

                                        if (conTimeout && conTimeout != "5s") {
                                            addProtocol.conn_timeout = conTimeout;
                                        }
                                    } catch (e) {/**/ }

                                }

                                if (protocol == protocolTypes[0]) {
                                    try {
                                        let portValue = parseInt(formJson["port"]);

                                        if (portValue && portValue != 22 && port > 0 && port < 65535) {
                                            addProtocol.port = portValue;
                                        }
                                    } catch (e) {/**/ }

                                    try {
                                        let conTimeout = formJson["conn_timeout"];

                                        if (conTimeout && conTimeout != "5s") {
                                            addProtocol.conn_timeout = conTimeout;
                                        }
                                    } catch (e) {/**/ }
                                }
                                if (enableDebugConsole) { console.log("addProtocol ", addProtocol) }

                                window.postMessage(
                                    JSON.stringify({
                                        type: APPFACTOR.command,
                                        scanRaw: true,
                                        payload: addProtocol
                                    })
                                );

                                setCredName("");

                                clearList.map((el, i) => {
                                    try {
                                        if (i == 0) {
                                            document.querySelector("#" + el).focus();
                                        }

                                        if (el == "scan_username") {
                                            try {
                                                document.querySelector('input[name="scan_username"]').parentNode.querySelector('[aria-label="Clear"]').click();
                                            } catch (e) { }
                                            try {
                                                document.querySelector('input[name="scan_password"]').parentNode.querySelector('[aria-label="Clear"]').click();
                                            } catch (e) { }
                                        } else

                                            document.querySelector("#" + el).value = "";

                                    } catch (e) {/* */ }
                                })
                            }


                            if (error != "") {
                                setErrorText(error);
                            }

                            if (error == "") {
                                handleClose();
                            }
                        }

                        let createOk = false;

                        if (isStandard || protocol == protocolTypes[2]) {
                            try {
                                createOk = createCredential();
                            } catch (e) {
                                console.log(e);
                            }

                            if (!createOk) {
                                event.preventDefault();
                                document.querySelector(".scanButton[type='submit']").classList.remove("disabled");

                                return true;
                            } else {
                                let currentTarget = event.currentTarget;

                                let waitingSecretCreation = setInterval(() => {

                                    if (secretCreated(secretCreateID)) {
                                        clearInterval(waitingSecretCreation);
                                        createProtocol(event, currentTarget, theSecretName, suSecretKey);
                                        document.querySelector(".scanButton[type='submit']").classList.remove("disabled");
                                    }
                                }, 1000);
                            }
                        } else {
                            let formJsonOut = {};
                            function validateFormHV() {
                                let returnValue = true;
                                setErrorText("");

                                const formData = new FormData(formControlRef.current.parentNode);
                                const formJson = Object.fromEntries((formData).entries());
                                formJsonOut = JSON.parse(JSON.stringify(formJson));

                                let error = '';
                                if (!formJson["credName"] || formJson["credName"].length == 0) {
                                    error += "Credential name is invalid. ";
                                }

                                if (protocol == protocolTypes[2]) {
                                    if (!formJson["scan_account_name"] || formJson["scan_account_name"].length == 0) {
                                        error += "Account name missing. ";
                                    }

                                    if (!formJson["scan_access_secret"] || formJson["scan_access_secret"].length == 0) {
                                        error += "Account access secret is missing. ";
                                    }

                                    if (!formJson["scan_access_key"] || formJson["scan_access_key"].length == 0) {
                                        error += "Account access key missing. ";
                                    }

                                    if ((regionVal || "").length == 0) {
                                        error += "Region missing. ";
                                    }
                                }

                                if (protocol == protocolTypes[0] && credType == credTypes[1]) {
                                    if (!formJson["scan_username"] || formJson["scan_username"].length == 0) {
                                        error += "SSH user name missing. ";
                                    }
                                }


                                if (error.length > 0) {
                                    setErrorText(error);
                                    return false;
                                }

                                formJson.scan_secretName = theSecretName;
                                setLastCreatedRef(formJson.scan_secretName);

                                if (formJson.scan_secretName.length > 0) {
                                    if (formJson.scan_username?.length == 0) {
                                        setErrorText("Username missing.");

                                        return false;
                                    }

                                    if (protocol != protocolTypes[2]) {
                                        if (props.secretsList.includes(formJson.scan_secretName)) {
                                            setErrorText("Secret already exists");

                                            return false;
                                        } else {

                                            //winrm .... 
                                            if (credType == credTypes[0]) {
                                                if (formJson.scan_username.length == 0) {
                                                    setErrorText("Password is empty");

                                                    return false;
                                                }

                                                //ignore if scan_password is not present - ad credential from valut
                                                if (formJson.scan_password && formJson.scan_password.length == 0) {
                                                    setErrorText("Password is empty")

                                                    return false;
                                                }

                                                if (protocol == protocolTypes[0]) {
                                                    if (runAsType != runScanTypes[1] &&
                                                        !(runAsType == runScanTypes[0] && sudoORSu == sudoORSuTypes[0]) &&
                                                        !(runAsType == runScanTypes[2] && sudoORSu == sudoORSuTypes[0])
                                                    ) {
                                                        if (enableDebugConsole) console.log("formJson", formJson)
                                                        if (enableDebugConsole) console.log("create sudo_password_secret_ref")

                                                    } else {
                                                        if (enableDebugConsole) console.log("NOT CREATE -  sudo_password_secret_ref")
                                                    }
                                                }
                                            }
                                            else {
                                                if (formJson.key_data.length == 0) {
                                                    setErrorText("Key Data is empty")
                                                    return false;
                                                }

                                                if (protocol == protocolTypes[0]) {
                                                    if (runAsType != runScanTypes[1]) {
                                                        if (enableDebugConsole) console.log("create sudo_password_secret_ref payload", payloadsu)
                                                    } else {
                                                        if (enableDebugConsole) console.log("NOT CREATE -  sudo_password_secret_ref")
                                                    }
                                                }



                                            }
                                        }
                                    } else {
                                        // xxxxx
                                        returnValue = true;
                                    }


                                } else {
                                    returnValue = false;
                                    setErrorText("Secret name invalid.")
                                }

                                return returnValue;
                            }

                            let formJson = formJsonOut;
                            let retVal = validateFormHV(formJson);

                            formJsonOut.ra_scan_password = formJsonOut.ra_scan_password_hv;
                            formJsonOut.ra_scan_username = formJsonOut.ra_scan_username_hv;

                            if (runAsType == runScanTypes[0] && sudoORSu == sudoORSuTypes[1]) {
                                formJsonOut.ra_scan_username = "root";
                                formJsonOut.ra_scan_username_hv = "root";
                            }

                            if (retVal) {
                                let dataVals = {
                                    scan_username: document.querySelector('[data-name="scan_username"]').getAttribute("data-id"),
                                    // scan_password: document.querySelector('[data-name="scan_password"]').getAttribute("data-id"),
                                }

                                try {
                                    dataVals.scan_password = document.querySelector('[data-name="scan_password"]').getAttribute("data-id")
                                } catch (e) {

                                }


                                try {
                                    dataVals.ra_scan_username = document.querySelector('[data-name="ra_scan_username_hv"]').getAttribute("data-id")
                                } catch (e) { }

                                try {
                                    dataVals.ra_scan_password = document.querySelector('[data-name="ra_scan_password_hv"]').getAttribute("data-id")
                                } catch (e) {

                                }

                                let currentSecretHV = `${dataVals.scan_username}${dataVals.scan_password ? `,${dataVals.scan_password.split("#")[1]}` : ""}`;

                                let suCurrentSecretHV = ``;
                                try {
                                    let mainAddress = "";
                                    let mainUser = "";
                                    let mainPassword = "";
                                    try {
                                        mainAddress = dataVals.ra_scan_username.split("#")[0];
                                    }
                                    catch (e) {
                                        mainAddress = dataVals.ra_scan_password.split("#")[0];
                                    }

                                    try {
                                        mainUser = dataVals.ra_scan_username.split("#")[1];
                                    }
                                    catch (e) {
                                        mainUser = "root"
                                    }

                                    try {
                                        mainPassword = dataVals.ra_scan_password.split("#")[1];
                                    }
                                    catch (e) {
                                        mainPassword = "";
                                    }

                                    if (runAsType == runScanTypes[0] && sudoORSu == sudoORSuTypes[1]) {
                                        let passName = dataVals?.ra_scan_password?.split("#")[1] || undefined;
                                        if(typeof passName === "undefined"){
                                            suCurrentSecretHV =  dataVals.ra_scan_password;
                                        }else{
                                            suCurrentSecretHV = `${mainAddress}/${passName},${passName}`;
                                        }
                                    } 
                                    else {
                                        let passName = dataVals?.ra_scan_password?.split("#")[1] || undefined;
                                        if(typeof passName === "undefined" && (typeof dataVals?.ra_scan_password !== 'undefined') ){
                                            suCurrentSecretHV =  dataVals.ra_scan_password;
                                        }else{
                                            if(typeof mainUser == 'undefined'){
                                                suCurrentSecretHV = `${mainAddress}`;
                                            }else{
                                                suCurrentSecretHV = `${mainAddress}/${mainUser}${dataVals.ra_scan_password ? `,${passName}` : ""}`;
                                            }

                                        }
                                    }
                                   

                                    // suCurrentSecretHV = `${mainAddress}/${mainUser}${dataVals.ra_scan_password ? `,${dataVals.ra_scan_password.split("#")[1]}` : ""}`;
                                } catch (e) { 

                                }

                                let currentTarget = event.currentTarget;

                                createProtocol(event, currentTarget, currentSecretHV, suCurrentSecretHV, "ra_scan_username_hv");
                                document.querySelector(".scanButton[type='submit']").classList.remove("disabled");
                            } else {
                                event.preventDefault();
                                document.querySelector(".scanButton[type='submit']").classList.remove("disabled");
                            }
                        }
                    }
                },

            }}
            aria-describedby="addCredentialDialog"
        >
            <DialogLogo />
            <DialogTitle
                style={{
                    color: "rgba(255,255,255,1)",
                    marginTop: 0,
                    marginLeft: "9px",
                    marginBottom: 8,
                    padding:0,
                    paddingTop:"6px",
                    paddingLeft:"20px",
                }}
            >
                <div
                    style={{
                        color: "red",
                        position: "absolute",
                        marginTop: 0,
                        background: `rgba(6, 6, 6, ${errorText == "" ? 0 : 0.42})`,
                        fontSize: 14,
                        maxWidth: 430,
                        paddingLeft: 10,
                        minWidth: 430,
                        padding: 4,
                        right: 20,
                        borderRadius: 4,
                        maxHeight: "42px",
                        minHeight: "42px",
                        overflow: "scroll",
                        lineHeight: "14px !important"
                    }}

                >
                    &nbsp;{errorText}
                </div>
                <div style={{ display: "inline-block" ,fontSize:"16px"}}>Add Credential</div>
               



                {props.enableImport ? (
                    <div
                        style={{
                            position: "absolute",
                            right: 40,
                            top: 10
                        }}
                    >
                        <IFileUpload name="Import" />
                    </div>
                )
                    :
                    <></>
                }
            </DialogTitle>

            <DialogContent
                ref={formControlRef}
                style={{
                    margin: 0,
                    padding: 0,
                    paddingTop: "10px",
                    paddingLeft: "20px",
                    width: "calc(100% + 20px)",
                }}
            >
                 <div style={{  position: "absolute", width: "calc(100% - 145px)", marginTop:10,marginLeft:-33}}>
                    &nbsp;
                    <div>
                        <Select
                            className="add-credential"
                            labelId="select-standard"
                            id="select-standard"
                            value={isStandard ? 0 : 1}
                            onChange={(e) => {
                                if (e.target.value == 1 && hashicorpVaultToken == null) {
                                    setOpenHashSettings(true)
                                }

                                localStorage.setItem("defaultCredStandard", e.target.value == 0 ? "true" : "false")
                            }}
                            sx={{
                                background: "rgba(0,0,0,.24)",
                                color: "rgba(255,255,255,0.9)",
                            }}
                            style={{
                                ...tfield,
                                borderRadius: "8px",
                                fontSize: "14px",
                                fontWeight: "bold",
                                minWidth: 152,
                                paddingRight: 10,
                                maxHeight: 38,
                                position: "absolute",
                                marginLeft: 33,
                                marginTop: -33,
                            }}
                        >
                            <MenuItem value={0} onClick={() => setIsStandard(true)}>
                                <div style={{ display: "inline-block", position: "relative" }}>
                                    <div style={{ paddingLeft: 22, position: "absolute", marginLeft: 2, marginTop: -2 }}>
                                        <svg width="18" height="24" viewBox="0 0 24 24"
                                            style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                marginLeft: -4,
                                                marginRight: 110,
                                                marginTop: 1
                                            }}
                                            fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g opacity="0.8" clipPath="url(#clip0_1843_928)">
                                                <path d="M6 15C7.1 15 8 15.9 8 17C8 18.1 7.1 19 6 19C4.9 19 4 18.1 4 17C4 15.9 4.9 15 6 15ZM6 13C3.8 13 2 14.8 2 17C2 19.2 3.8 21 6 21C8.2 21 10 19.2 10 17C10 14.8 8.2 13 6 13ZM12 5C13.1 5 14 5.9 14 7C14 8.1 13.1 9 12 9C10.9 9 10 8.1 10 7C10 5.9 10.9 5 12 5ZM12 3C9.8 3 8 4.8 8 7C8 9.2 9.8 11 12 11C14.2 11 16 9.2 16 7C16 4.8 14.2 3 12 3ZM18 15C19.1 15 20 15.9 20 17C20 18.1 19.1 19 18 19C16.9 19 16 18.1 16 17C16 15.9 16.9 15 18 15ZM18 13C15.8 13 14 14.8 14 17C14 19.2 15.8 21 18 21C20.2 21 22 19.2 22 17C22 14.8 20.2 13 18 13Z" fill="white" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1843_928">
                                                    <rect width="24" height="24" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <div style={{ paddingLeft: 22 }}>Standard</div>
                                </div>
                            </MenuItem>
                            <MenuItem value={1} onClick={() => setIsStandard(false)}>
                                <div style={{ display: "inline-block" }}>
                                    <div style={{ position: "absolute", marginLeft: 2, marginTop: 1 }}>{ICON_HASHICORP_VAULT}</div>
                                    <div style={{ paddingLeft: 22, display: "inline-block", minwidth: 320, fontSize: "14px", }}>HashiCorp Vault</div></div></MenuItem>

                        </Select>

                        {!isStandard &&
                            <div style={{
                                width: 20,
                                height: 20,
                                borderRadius: "50%",
                                left: 218,
                                marginTop: -43,
                                position: "absolute",
                                zIndex: 9000,
                                pointerEvents: "none",

                                color: hashicorpVaultToken ? "#4EAF4E" : "rgba(255,255,255,0.8)",
                            }}

                            >{hashicorpVaultToken ? <>
                                <svg
                                    width={14}
                                    height={14}
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clipPath="url(#clip0_6232_7692)">
                                        <path
                                            d="M9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM7.5 12.75L3.75 9L4.8075 7.9425L7.5 10.6275L13.1925 4.935L14.25 6L7.5 12.75Z"
                                            fill="#4EAF4E"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_6232_7692">
                                            <rect width={18} height={18} fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </> : <>
                                <svg
                                    width={14}
                                    height={14}
                                    viewBox="0 0 48 48"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clipPath="url(#clip0_6215_6758)">
                                        <path
                                            d="M24 4C12.96 4 4 12.96 4 24C4 35.04 12.96 44 24 44C35.04 44 44 35.04 44 24C44 12.96 35.04 4 24 4ZM26 34H22V30H26V34ZM26 26H22V14H26V26Z"
                                            fill="#F74237"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_6215_6758">
                                            <rect width={48} height={48} fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>

                            </>}</div>
                        }
                    </div>


                    {!isStandard &&
                        <div style={{
                            position: "absolute",
                            left: 248,
                            marginTop: "-32px",

                            zIndex: 9000
                        }}
                            onClick={() => {
                                setOpenHashSettings(true)
                            }}
                        >
                            <svg
                                width={43}
                                height={36}
                                viewBox="0 0 44 37"
                                fill="transparent"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect opacity="1" width={44} height={37} rx={8} fill="rgb(0,0,0,.24)" strokeWidth={1} />
                                <g opacity="0.8" clipPath="url(#clip0_5343_8538)">
                                    <path
                                        d="M13 24V26H19V24H13ZM13 12V14H23V12H13ZM23 28V26H31V24H23V22H21V28H23ZM17 16V18H13V20H17V22H19V16H17ZM31 20V18H21V20H31ZM25 16H27V14H31V12H27V10H25V16Z"
                                        fill="#E8EAED"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_5343_8538">
                                        <rect width={24} height={24} fill="white" transform="translate(10 7)" />
                                    </clipPath>
                                </defs>
                            </svg>

                        </div>
                    }
                </div>
                
                {debuugEnabled &&
                    <>
                        <div style={{
                            border: "1px solid green",
                            width: 2000,
                            height: 50,
                            marginLeft: -1000,
                            zIndex: 10000,
                            pointerEvents: "none",
                            marginTop: 320,

                            position: "absolute",
                        }}>
                        </div>

                        <div style={{
                            border: "1px solid blue",
                            width: 2000,
                            height: 51,
                            marginLeft: -1000,
                            zIndex: 10000,
                            pointerEvents: "none",
                            marginTop: 400,

                            position: "absolute",
                        }}>
                        </div>
                        <div style={{
                            border: "1px solid purple",
                            width: 2000,
                            height: 51,
                            marginLeft: -1000,
                            zIndex: 10000,
                            pointerEvents: "none",
                            marginTop: 86,

                            position: "absolute",
                        }}>
                        </div>
                    </>
                }




                <FormControl
                    variant="standard"
                    sx={{
                        fontSize: "14px",
                        backgroundColor: "rgba(6,6,6,0.42)",
                        m: 0,
                        marginTop: "60px",
                        borderRadius: "8px",
                        // border:"1px solid red",
                        // marginLeft: "35px",
                        p: "40px",
                        minWidth: 300,
                        minHeight: 204,
                        width: "calc(100% - 140px)",
                        justifyContent: "flex-start"
                    }}
                >
                    <div style={{
                        width: "122px",
                        height: "12px",
                        color: "var(--text-color-add-form)",
                        marginTop: 0,
                        fontSize: "14px"
                    }}>
                        <div
                            className="protoTabTitle"
                            style={{
                                // webkitTextFillColor:"var(--text-color-add-form)",
                                // webkitTextStroke:"0.42px",
                                textTransform: "outline",
                                position: "absolute",
                                marginTop: -68,
                                // zIndex:1,
                                marginLeft: -27,

                            }}
                        >&nbsp;
                        <div style={{ position: "relative",marginTop:-56,marginLeft:271}}>
                    <HorizontalMenu
                      addLabel={false}
                      noScale={true}
                      alignleft={true} 
                      value={protocol}
                      setValue={setProtocol}
                      onChangeValue={(e, b) => {
                            let aw = window.xx;
                            let newProtocol = b;

                            window.postMessage(
                                JSON.stringify({
                                    type: APPFACTOR.command,
                                    scanRaw: true,
                                    payload: {
                                        "secret_type": "username_password",
                                        "type": "get_secrets",
                                        "id": "88888888-4444-4444-1111-121212121212",
                                        "store_password": localSecret,
                                    }
                                })
                            );

                            setProtocol(newProtocol);
                            sessionStorage.lastProtocolType = newProtocol;
                            setCredType(credTypes[0]);
                            setDomain("");
                            setPort(22);

                            if (credName == "") {
                                document.querySelector("#credName").focus();
                            } else if (aw) {
                                let mapFocus = {
                                    scan_username: "#scan_access_key",
                                    scan_password: "#scan_access_key",
                                }

                                if (b == protocolTypes[2]) {
                                    if (aw.id == "scan_username") {
                                        setTimeout(() => {
                                            document.querySelector("#scan_access_key").focus();
                                        }, 100);
                                    } else if (aw.id == "scan_password") {
                                        setTimeout(() => {
                                            document.querySelector("#scan_access_secret").focus();
                                        }, 100);
                                    } else {
                                        try {
                                            aw.focus();
                                        } catch (e) {
                                            /* */
                                        }
                                    }
                                } else {
                                    if (aw.id == "scan_access_key") {
                                        setTimeout(() => {
                                            document.querySelector("#scan_username").focus();
                                        }, 100);
                                    } else if (aw.id == "scan_access_secret") {
                                        setTimeout(() => {
                                            document.querySelector("#scan_password").focus();
                                        }, 100);
                                    } else {
                                        try {
                                            aw.focus();
                                        } catch (e) {
                                            /* */
                                        }
                                    }
                                }

                            }
                        
                      }}
                      menuItems={
                        protocolTypes.map((item, i) => {
                          return <div key={i} 
                          onMouseDown={(e) => {
                            window.xx = document.activeElement
                        }}
                          
                          onClick={(e) => {
                            setProtocol(item);
                          }}

                          style={{ display: "inline-block" }}>&nbsp;&nbsp;{item}&nbsp;&nbsp;</div>
                        })
                      }
                      menuValues={protocolTypes} >

                    </HorizontalMenu>
                    </div>
                        </div>
                        
                       

                        </div>





                    {false && <RadioGroup
                        slotProps={{ htmlInput: { tabIndex: -1 } }}
                        className="add-credential-radio-group protoTab"
                        aria-labelledby="cred-type-group"
                        name="protocol_selection"
                        value={protocol}
                        onMouseDown={(e) => {
                            window.xx = document.activeElement
                        }}
                        onChange={(a, b) => {
                            let aw = window.xx;
                            let newProtocol = b;

                            window.postMessage(
                                JSON.stringify({
                                    type: APPFACTOR.command,
                                    scanRaw: true,
                                    payload: {
                                        "secret_type": "username_password",
                                        "type": "get_secrets",
                                        "id": "88888888-4444-4444-1111-121212121212",
                                        "store_password": localSecret,
                                    }
                                })
                            );

                            setProtocol(newProtocol);
                            sessionStorage.lastProtocolType = newProtocol;
                            setCredType(credTypes[0]);
                            setDomain("");
                            setPort(22);

                            if (credName == "") {
                                document.querySelector("#credName").focus();
                            } else if (aw) {
                                let mapFocus = {
                                    scan_username: "#scan_access_key",
                                    scan_password: "#scan_access_key",
                                }

                                if (b == protocolTypes[2]) {
                                    if (aw.id == "scan_username") {
                                        setTimeout(() => {
                                            document.querySelector("#scan_access_key").focus();
                                        }, 100);
                                    } else if (aw.id == "scan_password") {
                                        setTimeout(() => {
                                            document.querySelector("#scan_access_secret").focus();
                                        }, 100);
                                    } else {
                                        try {
                                            aw.focus();
                                        } catch (e) {
                                            /* */
                                        }
                                    }
                                } else {
                                    if (aw.id == "scan_access_key") {
                                        setTimeout(() => {
                                            document.querySelector("#scan_username").focus();
                                        }, 100);
                                    } else if (aw.id == "scan_access_secret") {
                                        setTimeout(() => {
                                            document.querySelector("#scan_password").focus();
                                        }, 100);
                                    } else {
                                        try {
                                            aw.focus();
                                        } catch (e) {
                                            /* */
                                        }
                                    }
                                }

                            }
                        }}
                        style={{
                            transform: "scale(0.9)",
                            display: "inline-block",
                            marginBottom: 0,
                            marginLeft: "80px",
                            maxHeight: 12,
                            marginTop: -82,
                            color: "var(--text-color-add-form)",
                            left: 0,
                            position: "absolute"
                        }}
                    >
                        {protocolTypes.map((p, i) => {
                            return (
                                <FormControlLabel
                                    key={"p-" + i}
                                    value={p}
                                    control={<Radio tabIndex={-1} className="add-credential__radio-button" />}
                                    label={<>{
                                        <div style={{
                                            paddingLeft: 0,
                                            position: "relative",
                                            width: "90px",
                                            textAlign: "center",
                                            marginTop: 4,
                                            // marginLeft: -20,
                                            // border:"1px solid red"
                                        }}>


                                            <div style={{
                                                paddingTop: p == protocol ? 0 : 4,
                                                display: "inline-block",
                                                // paddingLeft: 10,
                                                color: p == protocol ? "rgba(255,255,255,1)" : "rgba(255,255,255,0.5)"
                                            }}

                                            >
                                                {`${p}`}
                                            </div>

                                        </div>


                                    }</>}
                                    style={{
                                        minWidth: 142,
                                        textTransform: "uppercase",
                                        fontSize: "14px",
                                        color: "var(--text-color-add-form)",
                                    }}
                                    onChange={(e) => {
                                        setProtocol(e.target.value);
                                    }}
                                />
                            )
                        })
                        }
                    </RadioGroup>}
                    <div
                        style={{
                            position: "absolute",
                            color: `${labelColor}`,
                            marginTop: 2,
                            flex: 1
                        }}>Credential name</div>

                    <TextField
                        slotProps={{ htmlInput: { tabIndex: 1 } }}
                        className="add-credential-input"
                        onBlur={() => {
                            setErrorText("");

                            if (props.existingProtocols.includes(credName)) {
                                setErrorText("Credential name already exists.");
                            }
                        }}
                        style={{
                            marginTop: 15,
                            marginLeft: 0,
                            marginBottom: 20,
                            maxWidth: 144,
                            minWidth: 144,
                        }}
                        // margin="dense"
                        id="credName"
                        name="credName"
                        placeholder=""
                        type="text"
                        autoFocus
                        value={credName}
                        onChange={(e) => {
                            setCredName(e.target.value);
                        }}
                        autoComplete="one-time-code"
                    />


                    <div
                        style={{
                            maxWidth: 706,
                            borderRadius: 0,
                            padding: 20,
                            display: "flex",
                            justifyContent: "flex-start",
                            gap: 0
                        }}
                    >
                        {protocol == protocolTypes[0] ?
                            <>
                                <div
                                    style={{
                                        position: "absolute",
                                        marginTop: -80,
                                        minWidth: 330,
                                        marginLeft: 124,
                                        display: "flex",
                                        gap: 0,
                                    }}
                                >
                                    {showOptional &&
                                        <>

                                            <div
                                                style={{
                                                    position: "absolute",
                                                    color: `${labelColor}`,

                                                    marginTop: -25,
                                                    marginLeft: 10,
                                                    flex: 1
                                                }}>Port</div>

                                            <TextField
                                                // Distinct key so React does not reconcile this against
                                                // the AWS-SSM tab's account-name field, which sits in the
                                                // same position. Both are uncontrolled, so reusing the DOM
                                                // node carried this default "22" across as the account name.
                                                key="ssh-port"
                                                slotProps={{ htmlInput: { tabIndex: 2 } }}
                                                className="add-credential"
                                                autoComplete={'one-time-code'}
                                                id="port"
                                                name="port"
                                                // label="Port"
                                                defaultValue={"22"}
                                                {...tfield}
                                                style={{
                                                    width: "74px",
                                                    minWidth: "74px",
                                                    maxWidth: "74px",
                                                    flex: 0.2,
                                                    marginLeft: 10,
                                                }}

                                            />

                                            <div
                                                style={{
                                                    position: "absolute",
                                                    color: `${labelColor}`,
                                                    marginTop: -25,
                                                    marginLeft: 95,
                                                    flex: 1
                                                }}>Connection timeout</div>

                                            <TextField
                                                slotProps={{ htmlInput: { tabIndex: 3 } }}
                                                className="add-credential"
                                                autoComplete={'one-time-code'}
                                                id="ctimeout"
                                                name="conn_timeout"
                                                // label="Connection timeout"
                                                defaultValue={"5s"}
                                                {...tfield}
                                                style={{
                                                    width: "172px",
                                                    minWidth: "172px",
                                                    maxWidth: "172px",
                                                    flex: 0.2,
                                                    marginLeft: 10,
                                                }}
                                            />

                                        </>
                                    }
                                </div>
                                <div
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        right: 0,
                                        borderRadius: "0 8px 8px 0",
                                        width: "410px",
                                        height: "100%",
                                        backgroundColor: "rgba(6,6,6,0.42)",
                                        margin: 0,
                                        padding: 0,
                                        // marginTop: -80,
                                        // minWidth: 330,
                                        // marginLeft: 124,
                                        // display: "flex",
                                        // gap: 0,
                                    }}
                                >
                                    <div
                                        style={{
                                            height: "calc(100% - 60px)",
                                            // border:"1px solid red",
                                            marginTop: 20,
                                            paddingTop: 20,
                                            paddingLeft: 20,
                                            fontSize: "18px",
                                            textAlign: "left",
                                            color: "var(--text-color-add-form)",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "left",
                                            alignItems: "left",
                                            gap: 0,
                                        }}
                                    >
                                        <div style={{
                                            marginTop: "-2px", paddingBottom: "2px"
                                        }}>Run scan using</div>


                                        <RadioGroup
                                            className="add-credential-radio-group noBG"
                                            aria-labelledby="runScanUsing"
                                            name="runScanUsing"
                                            value={runAsType}
                                            onChange={(a, b) => {
                                                setUserPathRa("");

                                                if (b == runScanTypes[0]) {
                                                    try {
                                                        document.querySelector('input[name="ra_scan_username"]').value = "root"
                                                    } catch (e) { }
                                                    try {
                                                        document.querySelector('input[name="ra_scan_password"]').value = "";
                                                    } catch (e) { }
                                                } else {

                                                    try {
                                                        document.querySelector('input[name="ra_scan_username"]').value = ""
                                                    } catch (e) { }
                                                    try {
                                                        document.querySelector('input[name="ra_scan_password"]').value = "";
                                                    } catch (e) { }

                                                    try {
                                                        document.querySelector('input[name="ra_scan_username_hv"]').parentNode.querySelector('[aria-label="Clear"]').click();
                                                    } catch (e) { }
                                                    try {
                                                        document.querySelector('input[name="ra_scan_password_hv"]').parentNode.querySelector('[aria-label="Clear"]').click();
                                                    } catch (e) { }
                                                }

                                                setRunAsType(b);
                                            }}
                                            sx={{
                                                transform: "scale(0.9)",
                                                marginTop: "-110px",
                                                marginLeft: "2px",
                                            }}
                                            style={{
                                                marginTop: 20,
                                                padding: 0,
                                                display: "flex",
                                                flexDirection: "column",
                                                color: "var(--text-color-add-form)",
                                                // marginLeft:20
                                            }}
                                        >
                                            <div style={{
                                                // transform:"scale(0.9)",
                                                display: "flex",
                                                flexDirection: "column",
                                                color: "var(--text-color-add-form)",
                                                marginBottom: "10px",
                                                marginTop: "-10px",
                                                marginLeft: "-20px",
                                            }}>
                                                {runScanTypes.map((type, index) => (
                                                    <FormControlLabel
                                                        title={`${titleExplain[type]}`}
                                                        key={index}
                                                        value={type}
                                                        control={
                                                            <Radio tabIndex={-1} className="add-credential__radio-button"
                                                                style={{
                                                                    minWidth: "20px",
                                                                    color: type == runAsType ? "rgba(255,255,255,1)" : "rgba(255,255,255,0.5)"
                                                                }}
                                                            />}
                                                        label={capitalize(decamelize(type))}
                                                        style={{
                                                            padding: 0,
                                                            marginLeft: 20,
                                                            minWidth: "120px",
                                                            justifyContent: "left",
                                                            // minWidth: "100%",
                                                            color: type == runAsType ? "var(--text-color-full)" : "var(--text-color-add-form) !important"
                                                        }}
                                                    />
                                                ))}
                                            </div>
                                        </RadioGroup>

                                        {(disable1 || disable2) &&
                                            <><div
                                                style={{
                                                    position: "absolute",
                                                    zIndex: 2,
                                                    marginTop: "325px",
                                                    marginLeft: "27px",
                                                    // border:"1px solid red",
                                                    width: "calc(100% - 90px)",
                                                    textAlign: "center",
                                                    fontSize: 12,
                                                    color: "rgba(255,255,255,1)"
                                                }}>
                                                {titleExplain[runAsType].split(".").map((part, index) => (
                                                    <div key={index}>{part}.</div>
                                                ))}
                                            </div></>}

                                        <div
                                            style={{
                                                zIndex: 2,
                                                pointerEvents: disable1 ? "none" : "all",
                                                opacity: disable1 || disable2 ? hiddenFieldOpa : 1,
                                                position: "relative",
                                                border: "0.42px solid rgba(255,255,255,0.124)",
                                                background: "rgba(29, 17, 17, 0)",
                                                display: "flex",
                                                // minWidth: 375
                                                width: "calc(100% - 21px)",
                                                maxWidth: "calc(100% - 21px)",
                                                borderRadius: "8px 8px 8px 8px",
                                                height: "220px",
                                                maxHeight: "220px",
                                                minHeight: "220px",
                                                flexDirection: "column",
                                                margin: 0,
                                                marginLeft: 0,
                                                marginRight: 0,
                                                marginTop: 9,
                                                marginBottom: 0,
                                                padding: 0,
                                                paddingLeft: 0,
                                                paddingTop: 90,
                                                gap: 0,
                                                fontSize: 14
                                            }}
                                        >
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    color: `${labelColor}`,
                                                    opacity: runAsType == runScanTypes[0] ? hiddenFieldOpa : 1,
                                                    // opacity: ( (runAsType == runScanTypes[0]) && isStandard) ? hiddenFieldOpa: 1,
                                                    marginTop: -31,
                                                    flex: 1,
                                                    marginLeft: 33,
                                                }}>{ra_userName[`${credType}`][`${runAsType}`][`${sudoORSu}`]} </div>

                                            {isStandard ?
                                                <>
                                                    <TextField
                                                        slotProps={{
                                                            htmlInput: {
                                                                tabIndex: runAsType == runScanTypes[0] ? -1 : 6
                                                            },
                                                            input: {
                                                                readOnly: runAsType == runScanTypes[0],
                                                            }
                                                        }}
                                                        className="add-credential"
                                                        style={{
                                                            pointerEvents: runAsType == runScanTypes[0] ? "none" : "all",
                                                            opacity: runAsType == runScanTypes[0] ? hiddenFieldOpa : 1,
                                                            ...sLevel1,
                                                            marginLeft: 32,
                                                            minWidth: 300,

                                                            marginTop: -7


                                                        }}
                                                        sx={{
                                                            "& input": {
                                                                // background:"rgba(27,26,26,1) !important"
                                                            }

                                                        }}

                                                        defaultValue={runAsType == runScanTypes[0] ? "root" : ""}
                                                        id="ra_scan_username"
                                                        onChange={(e) => {
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                e.preventDefault();
                                                                document.querySelector("#savecred").click();
                                                            }
                                                        }}
                                                        name="ra_scan_username"
                                                        type="text"
                                                        autoComplete={'one-time-code'}
                                                    />
                                                </>
                                                :
                                                <>
                                                    <div
                                                        style={{
                                                            pointerEvents: runAsType == runScanTypes[0] ? "none" : "all",
                                                            opacity: runAsType == runScanTypes[0] ? hiddenFieldOpa : 1,
                                                            ...sLevel1,
                                                            marginLeft: 9,
                                                            minWidth: 320,
                                                            marginTop: 3
                                                        }}
                                                    >
                                                        <HashiAutocomplete
                                                            pointerEvents={(runAsType != runScanTypes[2] ? "none" : "all")}
                                                            setUserPath={setUserPathRa}
                                                            optionsList={
                                                                runAsType == runScanTypes[0] ? (optionsList.
                                                                    filter(op => {
                                                                        return op.isUserRoot
                                                                    }).length > 0 ?
                                                                    optionsList.
                                                                        filter(op => {
                                                                            return op.isUserRoot
                                                                        })
                                                                    : optionsList)
                                                                    : optionsList

                                                            } top={-19} name="ra_scan_username_hv" tabIndex={4} />
                                                    </div>
                                                </>
                                            }

                                            <div
                                                style={{
                                                    position: "absolute",
                                                    color: `${labelColor}`,
                                                    opacity: disable3 ? 0 : 1,
                                                    marginTop: 48,
                                                    flex: 1,
                                                    marginLeft: 33,
                                                }}>
                                                {
                                                    userPathRa.indexOf("vault+ldap:") != 0 ?
                                                        ra_passwordName[`${credType}`][`${runAsType}`][`${sudoORSu}`] : ""
                                                }
                                                {
                                                    (runAsType == runScanTypes[0] && sudoORSu == sudoORSuTypes[0] && credType == credTypes[1]) || (runAsType == runScanTypes[2] && sudoORSu == sudoORSuTypes[0]) ?
                                                        <span className="username_value" style={{ color: "white" }}>{customUsernameString.length > 0 ? (<>&nbsp;(&nbsp;{customUsernameString}&nbsp;)</>) : ""}</span> : <></>}
                                            </div>




                                            {isStandard &&
                                                <TextField
                                                    slotProps={{ htmlInput: { tabIndex: disable3 ? -1 : 6 } }}
                                                    className="add-credential"
                                                    style={{
                                                        pointerEvents: disable3 ? "none" : "all",
                                                        opacity: disable3 ? 0 : 1,
                                                        ...sLevel1,
                                                        marginLeft: 32,
                                                        minWidth: 300,
                                                        marginTop: -66
                                                    }}
                                                    margin="dense"
                                                    id="ra_scan_password"
                                                    name="ra_scan_password"
                                                    // label="PASSWORD"
                                                    type="password"
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            e.preventDefault();
                                                            document.querySelector("#savecred").click()
                                                        }
                                                    }}
                                                    sx={{
                                                        "& input": {
                                                            // background:"rgba(27,26,26,1) !important"
                                                        }

                                                    }}
                                                    // variant="standard"
                                                    autoComplete={'one-time-code'}
                                                />
                                            }

                                            {!isStandard &&
                                                <div
                                                    style={{
                                                        pointerEvents: disable3 ? "none" : "all",
                                                        opacity: disable3 ? 0 : 1,
                                                        ...sLevel1,
                                                        marginLeft: 9,
                                                        minWidth: 320,
                                                        marginTop: -45
                                                    }}
                                                >
                                                    {(!disable3 || userPathRa.indexOf("vault+ldap:") == 0) &&
                                                        <HashiAutocomplete
                                                            pointerEvents={disable3 ? "none" : "all"}
                                                            userPath={userPathRa}
                                                            optionsList={
                                                                optionsList
                                                            } top={-19} name="ra_scan_password_hv" tabIndex={disable3 ? -1 : 6} />
                                                    }
                                                </div>
                                            }

                                        </div>


                                        <RadioGroup
                                            slotProps={{ htmlInput: { tabIndex: -1 } }}
                                            className="add-credential-radio-group noBG"
                                            aria-labelledby="runScanUsing"
                                            name="runScanUsing"
                                            value={sudoORSu}
                                            onChange={(a, b) => {
                                                setSudoORSu(b);
                                            }}
                                            style={{
                                                transform: "scale(0.9)",
                                                pointerEvents: disable1 ? "none" : "all",
                                                opacity: disable1 ? 0 : 1,
                                                marginTop: -304,
                                                marginLeft: -16,
                                                zIndex: 100,
                                                padding: 0,
                                                display: "flex",
                                                flexDirection: "row",
                                                color: "var(--text-color-add-form)",
                                            }}
                                        >
                                            {sudoORSuTypes.map((type, index) => (
                                                <FormControlLabel
                                                    title={`Change user using : ${type}`}
                                                    key={index}
                                                    value={type}
                                                    control={
                                                        <Radio tabIndex={-1} className="add-credential__radio-button"

                                                            style={{
                                                                minWidth: "20px",
                                                                color: type == sudoORSu ? "var(--text-color-full)" : "var(--text-color-add-form)"
                                                            }}
                                                        />}
                                                    label={capitalize(decamelize(type))}
                                                    style={{
                                                        padding: 0,
                                                        marginLeft: 20,                                                    // minWidth: "120px",
                                                        justifyContent: "left",
                                                        color: type == sudoORSu ? "var(--text-color-full)" : "var(--text-color-add-form)"
                                                    }}
                                                />
                                            ))}



                                        </RadioGroup>

                                    </div>
                                    <div
                                        style={{
                                            zIndex: 0,
                                            opacity: !(disable1 || disable2) ? hiddenFieldOpa : 1,
                                            pointerEvents: disable1 ? "none" : "all",
                                            position: "absolute",
                                            border: "0.42px solid rgba(255,255,255,0.124)",
                                            background: "rgba(29, 17, 17, 0)",
                                            display: "flex",
                                            // minWidth: 375,
                                            width: "calc(100% - 41px)",
                                            maxWidth: "calc(100% - 41px)",
                                            borderRadius: "8px 8px 8px 8px",
                                            height: "220px",
                                            maxHeight: "220px",
                                            minHeight: "220px",
                                            flexDirection: "column",
                                            margin: 0,
                                            marginTop: "-334px",
                                            marginLeft: "20px",
                                            marginRight: "0px",
                                            marginBottom: "0px",
                                            padding: "0px",
                                            paddingLeft: "0px",
                                            paddingTop: "90px",
                                            paddingBottom: "0px",
                                            paddingRight: "0px",
                                            gap: 0,
                                            fontSize: 14
                                        }}
                                    >

                                    </div>

                                </div>
                            </>
                            :
                            protocol == protocolTypes[1] ?
                                <div
                                    style={{
                                        position: "absolute",
                                        marginLeft: 124,
                                        marginTop: "-80px",
                                        display: "flex",
                                        gap: 10,
                                        // right:40,
                                        minWidth: 330,
                                    }}
                                >
                                    {isStandard &&
                                        <>
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    color: `${labelColor}`,
                                                    marginTop: -25,
                                                    marginLeft: 10,
                                                    flex: 1
                                                }}>Domain (optional)</div>

                                            <TextField
                                                slotProps={{ htmlInput: { tabIndex: 2 } }}
                                                className="add-credential"
                                                sx={{
                                                    ...sLevel2,
                                                    minWidth: 142,
                                                    maxWidth: 142,
                                                    marginLeft: "10px",
                                                }}

                                                id="scan_domain"
                                                name="scan_domain"
                                                value={domain}
                                                onChange={
                                                    (a, b) => {
                                                        setDomain(b)
                                                    }
                                                }
                                                // label="Domain (optional)"
                                                type="text"
                                                // variant="outlined"
                                                defaultValue={""}
                                                autoComplete={'one-time-code'}
                                            />
                                        </>}
                                    <div
                                        style={{
                                            position: "absolute",
                                            color: `${labelColor}`,
                                            marginTop: -25,
                                            marginLeft: 162,
                                            minwidth: 200,
                                            flex: 1
                                        }}>Connection timeout</div>

                                    <TextField
                                        slotProps={{ htmlInput: { tabIndex: 3 } }}
                                        className="add-credential"
                                        autoComplete={'one-time-code'}
                                        id="ctimeout"
                                        name="conn_timeout"
                                        // label="Connection timeout"
                                        defaultValue={"5s"}
                                        {...tfield}
                                        style={{
                                            width: "152px",
                                            minWidth: "152px",
                                            maxWidth: "152px",
                                            flex: 0.2,
                                            marginLeft: isStandard ? 0 : 162,
                                        }}
                                    />


                                </div>
                                : (
                                    <>
                                        <div
                                            style={{
                                                // border: "1px solid red",
                                                display: "inline-block",
                                                marginLeft: "32px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    color: `${labelColor}`,
                                                    marginTop: -105,
                                                    marginLeft: 104,
                                                    flex: 1
                                                }}>Account name</div>

                                            <TextField
                                                // See the SSH port field: without a distinct key these two
                                                // share a DOM node across tabs and the port default leaks
                                                // in here as the account name.
                                                key="ssm-account-name"
                                                slotProps={{ htmlInput: { tabIndex: 4 } }}
                                                className="add-credential"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        document.querySelector("#savecred").click()
                                                    }
                                                }}
                                                autoComplete={'one-time-code'}
                                                style={{
                                                    ...sLevel1,
                                                    marginTop: "-80px",
                                                    marginLeft: "102px",
                                                    fontSize: 20,
                                                    maxWidth: 244,
                                                    minWidth: 244
                                                }}
                                                id="scan_account_name"
                                                name="scan_account_name"
                                                // label="Account name"
                                                type="text"
                                                margin="dense"
                                            // variant="outlined"
                                            />
                                        </div>

                                        <div
                                            style={{
                                                transformOrigin: "0 0",
                                                marginTop: -119,
                                                zIndex: 99,
                                                display: "inline-block"
                                            }}
                                        >
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    color: `${labelColor}`,
                                                    marginTop: 14,
                                                    marginLeft: 94,
                                                    flex: 1
                                                }}>Region</div>
                                            <Autocomplete
                                                disablePortal
                                                style={{
                                                    ...sLevel1,
                                                    fontSize: 10,
                                                    minWidth: 290,
                                                    maxWidth: 290,
                                                    maxHeight: "12px",
                                                    minHeight: "12px",
                                                    height: "12px",
                                                }}
                                                autoHighlight
                                                id="scan_region"
                                                name="scan_region"
                                                // label="REGION"
                                                // placeholder=""
                                                // freeSolo
                                                autoComplete={'one-time-code'}
                                                value={regionVal}
                                                onInputChange={
                                                    (a, b) => {
                                                        setRegionVal(b)
                                                    }}
                                                onChange={
                                                    (a, b) => {
                                                        setRegionVal(b)
                                                    }}
                                                // margin="dense"
                                                options={AWS_REGIONS}
                                                renderInput={(params) => {
                                                    params.inputProps.tabIndex = 5;
                                                    return (
                                                        <TextField
                                                            className="add-credential"
                                                            {...params}
                                                            sx={{
                                                                ...sLevel2,
                                                                fontSize: 10,
                                                                minWidth: 290,
                                                                maxWidth: 290,
                                                                maxHeight: "12px",
                                                                minHeight: "12px",
                                                                height: "12px",
                                                                marginLeft: "0px",
                                                            }}
                                                            autoComplete="one-time-code"
                                                        />
                                                    )
                                                }}
                                            />
                                        </div>


                                    </>
                                )
                        }
                    </div>

                    {/* <div style={{ position: "absolute", transform:"scale(2.8)",
transformOrigin:"0 0",
zIndex: -1,
    marginTop: 104, marginLeft: -30, width: "120px",pointerEvents:"none", height: "120px", zIndex:1,
     color:"rgba(13,10,9,1)" }}>
<LabelShapeSVG width={188} height={145} stroke={"rgba(13,10,9,1)"} strokeOpacity={0} fillOpacity={1} />

                        </div> */}



                    <div
                        style={{
                            zIndex: 2,
                            position: "relative",
                            background: "rgba(13,10,9,1)",
                            display: "flex",
                            minWidth: 377,
                            maxWidth: protocol == protocolTypes[0] ? 377 : "calc(100% - 30px)",
                            borderRadius: "8px 8px 8px 8px",
                            height: "204px",
                            maxHeight: "204px",
                            minHeight: "204px",
                            flexDirection: "column",
                            margin: 0,
                            marginLeft: 0,
                            marginTop: 50,
                            marginBottom: 0,
                            padding: 20,
                            paddingLeft: 15,
                            paddingBotton: 30,
                            paddingTop: 90,
                            gap: 10
                        }}
                    >
                        {
                            protocol == protocolTypes[0] && (
                                <div
                                    style={{
                                        position: "absolute",
                                        fontSize: "14px",
                                        marginTop: -170,
                                        marginLeft: -15,
                                        color: "var(--text-color-add-form)"
                                    }}
                                >
                                    Login with
                                </div>
                            )}



                        <RadioGroup
                            slotProps={{ htmlInput: { tabIndex: -1 } }}
                            className="add-credential-radio-group"
                            aria-labelledby="cred-type-group"
                            name="credType"
                            value={credType}
                            onChange={(a, b) => {
                                window._g.credType = b;
                                window.postMessage(
                                    JSON.stringify(
                                        {
                                            type: APPFACTOR.command,
                                            scanRaw: true,
                                            payload:
                                            {
                                                "secret_type": b == "username_password" ? b : "ssh_key",
                                                "type": "get_secrets",
                                                "id": "88888888-4444-4444-4444-121212121212",
                                                "store_password": localSecret,
                                            }
                                        }
                                    )
                                );

                                setCredType(b)
                            }}
                            style={{
                                opacity: protocol == protocolTypes[0] ? 1 : 0,
                                transform: "scale(0.9)",
                                display: "inline-block",
                                marginBottom: 0,
                                marginLeft: "-9px",

                                marginTop: -132,

                                color: "var(--text-color-add-form)",
                                left: 0,
                                position: "absolute",
                            }}
                        >
                            <FormControlLabel
                                style={{
                                    minWidth: 122,
                                    // marginLeft: -40.5,
                                    // marginTop: -14,
                                    color: credType == credTypes[0] ? "var(--text-color-full)" : "var(--text-color-add-form)"
                                }}
                                value={credTypes[0]}
                                control={<Radio tabIndex={-1} className="add-credential__radio-button" />}
                                label={protocol != protocolTypes[2] ? "Password" : "KEY/SECRET"}
                            />

                            {protocol == protocolTypes[0] ? (
                                <FormControlLabel
                                    value={credTypes[1]}
                                    control={<Radio tabIndex={-1} className="add-credential__radio-button" />}
                                    label="Private key"
                                    style={{
                                        color: credType == credTypes[1] ? "var(--text-color-full)" : "var(--text-color-add-form)"
                                    }}
                                />
                            ) : <></>}
                        </RadioGroup>

                        {credType == credTypes[0] || credType == credTypes[1] ?
                            <>
                                {protocol == protocolTypes[0] || protocol == protocolTypes[1] || protocol == protocolTypes[2] ?
                                    <>
                                        <div className={"noScroll"} style={{
                                            display: "flex",
                                            gap: 15,
                                            position: "relative",
                                        }}>
                                            <div
                                                style={{
                                                    maxHeight: 1000,
                                                    minHeight: protocol == protocolTypes[2] ? 200 : 200,
                                                    position: "relative",
                                                    minWidth: 345,
                                                    paddingTop: 4,
                                                    borderRadius: 8,
                                                    flex: protocol == protocolTypes[0] ? 0.5 : 1,
                                                }}
                                                onClick={() => {
                                                    setEnableAdd(true)
                                                }}
                                            >
                                                {enableAdd ?
                                                    <>
                                                        {protocol != protocolTypes[2] ?
                                                            <>
                                                                <div
                                                                    style={{
                                                                        position: "absolute",
                                                                        color: `${labelColor}`,

                                                                        marginTop: -35,
                                                                        flex: 1,
                                                                        marginLeft: 25,
                                                                    }}>Login username</div>

                                                                {isStandard ?
                                                                    <TextField
                                                                        slotProps={{ htmlInput: { tabIndex: 4 } }}
                                                                        className="add-credential"
                                                                        style={{

                                                                            ...sLevel1,
                                                                            marginLeft: 25,
                                                                            minWidth: protocol == protocolTypes[0] ? 332 : "calc(100% - 60px)",
                                                                            // minWidth:  (credType == credTypes[0])?315:315,
                                                                            // maxWidth:  (credType == credTypes[0])?315:315,
                                                                            marginTop: -10,
                                                                        }}
                                                                        margin="dense"
                                                                        id="scan_username"
                                                                        onChange={(e) => {
                                                                            try {
                                                                                setCustomUsernameString(e.target.value || "");
                                                                            } catch (e) { /**/ }
                                                                        }}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                e.preventDefault();
                                                                                document.querySelector("#savecred").click();
                                                                            }
                                                                        }}
                                                                        name="scan_username"
                                                                        type="text"
                                                                        autoComplete={'one-time-code'}
                                                                    /> : <>
                                                                        <div>
                                                                            <HashiAutocomplete
                                                                                widthAdjust={protocol == protocolTypes[1] ? 80 : 0}
                                                                                setUserPath={setUserPath}
                                                                                optionsList={optionsList}
                                                                                top={-19}
                                                                                name="scan_username"
                                                                                tabIndex={4} />
                                                                        </div>

                                                                    </>}

                                                                {credType == credTypes[0] ?
                                                                    <>
                                                                        {isStandard ?
                                                                            <TextField
                                                                                slotProps={{ htmlInput: { tabIndex: 5 } }}
                                                                                className="add-credential"
                                                                                style={{
                                                                                    ...sLevel1,
                                                                                    marginLeft: 25,
                                                                                    minWidth: protocol == protocolTypes[0] ? 332 : "calc(100% - 60px)",
                                                                                    marginTop: 40
                                                                                }}
                                                                                margin="dense"
                                                                                id="scan_password"
                                                                                name="scan_password"
                                                                                // label="PASSWORD"
                                                                                type="password"
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === 'Enter') {
                                                                                        e.preventDefault();
                                                                                        document.querySelector("#savecred").click()
                                                                                    }
                                                                                }}
                                                                                // variant="standard"
                                                                                autoComplete={'one-time-code'}
                                                                            /> :
                                                                            <div>
                                                                                {userPath.indexOf("vault+ldap:") != 0 &&
                                                                                    <HashiAutocomplete
                                                                                        widthAdjust={protocol == protocolTypes[1] ? 80 : 0}
                                                                                        userPath={userPath}
                                                                                        optionsList={userPath.length > 0 ? optionsList : []}
                                                                                        top={58}
                                                                                        name="scan_password"
                                                                                        tabIndex={5}
                                                                                    />}
                                                                            </div>
                                                                        }

                                                                        {((userPath.indexOf("vault+ldap:") != 0) || isStandard) && <div
                                                                            style={{
                                                                                position: "absolute",
                                                                                color: `${labelColor}`,

                                                                                marginTop: isStandard ? 45 : -38,
                                                                                flex: 1,
                                                                                marginLeft: 25,
                                                                            }}>Login password</div>
                                                                        }
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <div
                                                                            style={{
                                                                                position: "relative"
                                                                            }}
                                                                        >
                                                                            <div
                                                                                className="kdataButton"
                                                                                style={{
                                                                                    position: "absolute",
                                                                                    marginTop: 34,
                                                                                    marginLeft: 0,
                                                                                    transform: "scale(0.8)"
                                                                                }}>
                                                                                <IFileUpload name="KEY DATA" />
                                                                            </div>
                                                                        </div>
                                                                        <TextField
                                                                            slotProps={{
                                                                                htmlInput: { tabIndex: 5 }
                                                                            }}
                                                                            className="kdata"
                                                                            style={{
                                                                                ...sLevel1,
                                                                                marginTop: 67,
                                                                                marginLeft: 25,
                                                                                minWidth: 332,
                                                                                maxWidth: 332,
                                                                            }}

                                                                            id="key_data"
                                                                            name="key_data"
                                                                            label=""
                                                                            multiline
                                                                            rows={7}
                                                                            defaultValue=""
                                                                            variant="filled"
                                                                            autoComplete={'one-time-code'}
                                                                        />

                                                                    </>
                                                                }
                                                            </>
                                                            : <div style={{
                                                                flex: 111,
                                                                fontSize: 10,
                                                                marginLeft: -7,
                                                                maxWidth: "calc(100% - 40px)",
                                                                minWidth: "calc(100% - 40px)",
                                                            }}>
                                                                <div
                                                                    style={{
                                                                        position: "absolute",
                                                                        color: `${labelColor}`,
                                                                        fontSize: "14px",
                                                                        marginTop: -35,
                                                                        flex: 1,
                                                                        marginLeft: 33,
                                                                    }}>ACCESS KEY</div>
                                                                <TextField
                                                                    slotProps={{ htmlInput: { tabIndex: 5 } }}
                                                                    className="add-credential"
                                                                    sx={{
                                                                        ...sLevel1,
                                                                        marginLeft: '32px',
                                                                        marginTop: "-10px",
                                                                        width: "calc(100% + 5px)",
                                                                        minWidth: "calc(100% - 5px)",
                                                                        maxWidth: "calc(100% - 5px)",
                                                                    }}
                                                                    margin="dense"
                                                                    id="scan_access_key"
                                                                    name="scan_access_key"
                                                                    // label="ACCESS KEY"
                                                                    type="text"
                                                                    autoComplete={'one-time-code'}
                                                                />
                                                                <div
                                                                    style={{
                                                                        position: "absolute",
                                                                        color: `${labelColor}`,
                                                                        fontSize: "14px",
                                                                        marginTop: 45,
                                                                        flex: 1,
                                                                        marginLeft: 33,
                                                                    }}>ACCESS SECRET</div>
                                                                <TextField
                                                                    slotProps={{ htmlInput: { tabIndex: 6 } }}
                                                                    className="add-credential"
                                                                    sx={{
                                                                        ...sLevel1,
                                                                        marginLeft: '32px',
                                                                        marginTop: "40px",
                                                                        width: "calc(100% + 5px)",
                                                                        minWidth: "calc(100% - 5px)",
                                                                        maxWidth: "calc(100% - 5px)",
                                                                    }}
                                                                    margin="dense"
                                                                    id="scan_access_secret"
                                                                    name="scan_access_secret"
                                                                    // label="ACCESS SECRET"
                                                                    type="password"
                                                                    autoComplete={'one-time-code'}

                                                                />


                                                            </div>
                                                        }
                                                    </>
                                                    : (
                                                        <>
                                                            <TextField
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter') {
                                                                        e.preventDefault();

                                                                        document.querySelector("#savecred").click();
                                                                    }
                                                                }}
                                                                style={{
                                                                    ...sLevel1,
                                                                    marginLeft: 20,
                                                                    marginTop: -70,
                                                                    opacity: 0,
                                                                    minWidth: 390,
                                                                    maxWidth: 390,
                                                                }}
                                                                autoComplete="one-time-code"
                                                                placeholder="secret label"
                                                                margin="dense"
                                                                id="scan_secretName"
                                                                name="scan_secretName"
                                                                label=""
                                                                type="text"
                                                                variant="standard"
                                                            />

                                                            <div
                                                                style={{
                                                                    display: "inline-block",
                                                                    marginLeft: 160,
                                                                    marginTop: 60,
                                                                    color: "rgba(255,255,255,0.2)",
                                                                    transform: "scale(13)"
                                                                }}
                                                            >
                                                                +
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <></>
                                }
                            </>
                            :
                            <></>
                        }
                    </div>
                </FormControl>


            </DialogContent>

            <DialogActions
                style={{
                    marginTop: 0,
                    marginLeft: "12px",
                    position: "relative",
                    justifyContent: "left",
                    gap: 12,
                    paddingTop: 0,
                    paddingBottom: 0
                }}
            >
                <Button
                    tabIndex={10}
                    id="savecred"
                    className="scanButton add-credential__save"
                    sx={{
                        backgroundColor: "rgba(222,222,239,0.1) !important",
                    }}
                    type="submit"
                >{saveName}
                </Button>

                <Button
                    tabIndex={-1}
                    className="add-credential__cancel"
                    onClick={() => {
                        setErrorText("");
                        setCredName("");
                        handleClose();
                    }}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
        {openHashSettings &&
            <HashSettings
                vaultExistingNamespaces={vaultExistingNamespaces}
                setHashiAuthType={setHashiAuthType}
                loginFinished={loginFinished}
                hashicorpVaultSettings={hashicorpVaultSettings}
                open={openHashSettings}
                setSettings={setHashicorpVaultSettings}
                settings={hashicorpVaultSettings}
                hashicorpVaultToken={hashicorpVaultToken}
                setHashicorpVaultToken={setHashicorpVaultToken}
                response={response}
                setResponse={setResponse}
                onClose={() => {
                    setOpenHashSettings(false);
                    let vtSettings = localStorage.getItem("hashicorpVaultSettings") ? JSON.parse(localStorage.getItem("hashicorpVaultSettings")) : null

                    setHashicorpVaultSettings(vtSettings);
                }
                } />}
    </>
    );
}

export default AddCredential;
